(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7930],{

/***/ 1210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_GithubOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/GithubOutlined.js
// This icon file is generated automatically.
var GithubOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9a127.5 127.5 0 0138.1 91v112.5c.8 9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z" } }] }, "name": "github", "theme": "outlined" };
/* harmony default export */ var asn_GithubOutlined = (GithubOutlined);

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 2 modules
var AntdIcon = __webpack_require__(84089);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/GithubOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var GithubOutlined_GithubOutlined = function GithubOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
    ref: ref,
    icon: asn_GithubOutlined
  }));
};

GithubOutlined_GithubOutlined.displayName = 'GithubOutlined';
/* harmony default export */ var icons_GithubOutlined = (/*#__PURE__*/react.forwardRef(GithubOutlined_GithubOutlined));

/***/ }),

/***/ 61863:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/talent-plan",
      function () {
        return __webpack_require__(70597);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 33358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Link */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22745);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  &,\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Link = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].a.attrs */ .ZP.a.attrs({
    target: "_blank",
    rel: "noreferrer"
})(_templateObject(), _colors__WEBPACK_IMPORTED_MODULE_1__.B1);
Link.propTypes = {
    href: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired)
};
/* harmony default export */ __webpack_exports__["Z"] = (Link);


/***/ }),

/***/ 78763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$0": function() { return /* binding */ Section; },
/* harmony export */   "$C": function() { return /* binding */ ModuleTitle; },
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "Pu": function() { return /* binding */ CenterOnSmallScreen; },
/* harmony export */   "VY": function() { return /* binding */ Content; },
/* harmony export */   "xv": function() { return /* binding */ Text; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22745);
/* harmony import */ var _mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52873);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      padding: 3rem 0;\n\n      ",
        " {\n        font-size: 24px;\n        margin-bottom: 3rem;\n        text-align: center;\n\n        &::after {\n          left: 50%;\n          bottom: -10px;\n          margin-left: -1.5rem;\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  background: ",
        ";\n  padding: 4rem 0 6rem;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  font-size: 32px;\n  margin-bottom: 4rem;\n\n  && {\n    font-weight: normal;\n  }\n\n  &::after {\n    ",
        ";\n    content: '';\n    background: ",
        ";\n    position: absolute;\n    bottom: -6px;\n    left: 0;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      justify-content: ",
        ";\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  justify-content: space-between;\n  line-height: 1;\n  font-size: 20px;\n  font-weight: normal !important;\n  margin-bottom: 2rem;\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 16px;\n  color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        "\n      text-align: center;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var Section = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject1(), _colors__WEBPACK_IMPORTED_MODULE_1__.F1, _colors__WEBPACK_IMPORTED_MODULE_1__.M1, function(props) {
    return props.isSmallScreen && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(_templateObject(), Title);
});
var Content = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject2(), _mixins__WEBPACK_IMPORTED_MODULE_2__/* .responsive */ .jW());
var Title = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h2 */ .ZP.h2(_templateObject3(), _mixins__WEBPACK_IMPORTED_MODULE_2__/* .size */ .dp("3rem", "10px"), _colors__WEBPACK_IMPORTED_MODULE_1__.B1);
var ModuleTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h3 */ .ZP.h3(_templateObject5(), _mixins__WEBPACK_IMPORTED_MODULE_2__/* .flexVerticalCenter */ .VL(), function(props) {
    return props.justify && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(_templateObject4(), props.justify);
});
var Text = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject6(), _colors__WEBPACK_IMPORTED_MODULE_1__.F2);
var CenterOnSmallScreen = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject8(), function(props) {
    return props.isSmallScreen && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(_templateObject7(), _mixins__WEBPACK_IMPORTED_MODULE_2__/* .centerBlock */ .EM());
});


/***/ }),

/***/ 580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Anchor; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function Anchor(_param) {
    var target = _param.target, rel = _param.rel, isHash = _param.isHash, href = _param.href, rest = _objectWithoutProperties(_param, [
        "target",
        "rel",
        "isHash",
        "href"
    ]);
    var props = _objectSpread({}, rest);
    //const isInternalLink = rest.href.charAt(0) === '/'
    //const hasHash = props.href.includes('#') && isInternalLink
    props.target = isHash ? "" : target !== null && target !== void 0 ? target : "_blank";
    props.rel = isHash ? "" : rel !== null && rel !== void 0 ? rel : "noopener noreferrer";
    // Add path prefix
    if (href && href.startsWith("/") && !href.startsWith("//") && !href.startsWith("/tidbcommunity")) {
        href = "/tidbcommunity" + href;
    }
    props.href = href;
    var _children;
    var children = (_children = props.children) !== null && _children !== void 0 ? _children : props.href;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", _objectSpread({}, props, {
        children: children
    }));
};


/***/ }),

/***/ 66327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75302);

var useIsSmallScreen = function() {
    var breakpoint = antd__WEBPACK_IMPORTED_MODULE_0__/* ["default"].useBreakpoint */ .ZP.useBreakpoint();
    return {
        isSmallScreen: !breakpoint.md,
        breakpoint: breakpoint
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useIsSmallScreen);


/***/ }),

/***/ 89501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TwoColumnsSection_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./packages/ui/src/styled.ts
var styled = __webpack_require__(78763);
;// CONCATENATED MODULE: ./src/layouts/twoColumnsSection/twoColumnsSection.styled.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var Content = styled/* Content */.VY, Title = styled/* Title */.Dx;

var LeftPanel = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).attrs(function(props) {
    return {
        xs: {
            span: 24,
            order: props.$reverseOnSmallScreen ? 2 : 1
        },
        md: {
            span: 13,
            order: 1
        }
    };
})(_templateObject());
var RightPanel = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).attrs(function(props) {
    return {
        xs: {
            span: 24,
            order: props.$reverseOnSmallScreen ? 1 : 2
        },
        md: {
            span: 8,
            order: 2
        }
    };
})(_templateObject1());

;// CONCATENATED MODULE: ./src/layouts/twoColumnsSection/TwoColumnsSection.component.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var TwoColumnsSection = function(props) {
    var title = props.title, leftPanel = props.leftPanel, rightPanel = props.rightPanel, $reverseOnSmallScreen = props.$reverseOnSmallScreen, rest = _objectWithoutProperties(props, [
        "title",
        "leftPanel",
        "rightPanel",
        "$reverseOnSmallScreen"
    ]);
    var panelProps = {
        $reverseOnSmallScreen: $reverseOnSmallScreen
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, _objectSpread({}, rest, {
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                justify: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftPanel, _objectSpread({}, panelProps, {
                        children: leftPanel
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RightPanel, _objectSpread({}, panelProps, {
                        children: rightPanel
                    }))
                ]
            })
        ]
    }));
};
/* harmony default export */ var TwoColumnsSection_component = (TwoColumnsSection);

;// CONCATENATED MODULE: ./src/layouts/twoColumnsSection/index.ts



/***/ }),

/***/ 70597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/index.js + 20 modules
var components = __webpack_require__(21679);
// EXTERNAL MODULE: ./src/layouts/index.js + 12 modules
var layouts = __webpack_require__(70230);
// EXTERNAL MODULE: ./node_modules/antd/es/space/index.js + 1 modules
var space = __webpack_require__(26713);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 5 modules
var tooltip = __webpack_require__(36084);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(16165);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/GithubOutlined.js + 1 modules
var GithubOutlined = __webpack_require__(1210);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/MailOutlined.js + 1 modules
var MailOutlined = __webpack_require__(88641);
// EXTERNAL MODULE: ./src/hooks/useIsSmallScreen.js
var useIsSmallScreen = __webpack_require__(66327);
// EXTERNAL MODULE: ./src/layouts/twoColumnsSection/index.ts + 2 modules
var twoColumnsSection = __webpack_require__(89501);
// EXTERNAL MODULE: ./src/utils/index.js + 2 modules
var utils = __webpack_require__(49714);
;// CONCATENATED MODULE: ./src/pages/talent-plan/talent-plan.utils.js

var getImage = function(name) {
    return utils/* cdn.getImageUrl */.cK.getImageUrl("/images/talent-plan/".concat(name));
};

// EXTERNAL MODULE: ./src/components/Anchor.tsx
var Anchor = __webpack_require__(580);
;// CONCATENATED MODULE: ./src/pages/talent-plan/banner/AtomGitSvg.jsx


var AtomGitSvg = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        t: "1717469805373",
        viewBox: "0 0 1024 1024",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "p-id": "1512",
        width: "14",
        height: "14",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M416 1017.76c-60.517333-9.973333-140.032-40.48-150.549333-57.76-3.392-5.568 17.6-77.776 68.997333-237.333333C402.736 510.650667 409.413333 492.805333 422.88 486.346667c16.192-7.76 129.845333-10.474667 167.6-4l22.48 3.861333 34.416 104.896c70.698667 215.472 115.290667 356.906667 115.290667 365.653333 0 16.453333-86.741333 49.706667-160.613334 61.573334-41.424 6.656-144.16 6.341333-186.053333-0.570667z m-280.229333-154.538667c-26.778667-24.688-61.984-75.504-87.28-125.994666-13.056-26.069333-15.552-35.68-11.306667-43.616 8.4-15.690667 83.258667-79.04 127.642667-108.016 69.984-45.685333 163.728-85.312 169.04-71.456 3.696 9.621333-134.741333 344.154667-148.64 359.194666-15.344 16.608-21.92 15.264-49.456-10.112zM838.933333 873.333333c-6.010667-6.602667-13.381333-16.8-16.373333-22.666666C807.893333 821.973333 688 523.413333 688 515.621333c0-11.696 4.042667-11.36 44.069333 3.706667 74.496 28.042667 160.997333 82.597333 222.346667 140.234667l39.744 37.338666-14.277333 32.922667c-27.317333 62.986667-99.002667 155.509333-120.48 155.509333-5.253333 0-14.464-5.397333-20.474667-12z m117.546667-315.658666c-67.594667-35.328-128.186667-57.509333-219.914667-80.506667-39.290667-9.850667-73.157333-19.84-75.264-22.208-9.92-11.125333-70.277333-167.370667-67.477333-174.666667 2.789333-7.28 25.589333-8.293333 186.522667-8.293333 207.168 0 190.042667-3.696 210.122666 45.333333 20.437333 49.904 33.562667 126.074667 33.461334 194.224-0.069333 50.608-3.349333 75.418667-9.882667 74.773334-1.856-0.181333-27.765333-13.077333-57.568-28.656zM3.36 569.333333c-8.96-33.424 1.402667-156.869333 17.877333-213.077333 10.48-35.749333 31.168-77.424 40.149334-80.869333 11.274667-4.330667 350.928-4.469333 362.176-0.149334 4.64 1.781333 8.437333 6.032 8.437333 9.450667 0 11.146667-68.933333 170.432-75.52 174.506667-3.525333 2.181333-22.176 6.88-41.445333 10.453333C234.106667 484.624 125.456 523.072 53.333333 562.256c-40.928 22.229333-45.728 22.912-49.973333 7.072z m427.205333-122.218666c-5.685333-3.52 24.746667-108.928 42.325334-146.624 16.362667-35.072 61.994667-35.072 78.090666 0 13.829333 30.138667 47.296 136.677333 45.050667 143.413333-1.6 4.789333-23.434667 6.586667-80.949333 6.666667-43.322667 0.053333-81.354667-1.504-84.517334-3.456zM408 242.272c-11.733333-1.114667-50.133333-4.704-85.333333-7.973333-70.485333-6.549333-199.888-29.701333-207.498667-37.12-7.477333-7.290667 31.141333-50.762667 78.048-87.850667C285.109333 36.661333 391.626667 0.197333 512 0.197333c140.037333 0 261.898667 49.056 361.333333 145.456 37.12 35.984 44.346667 47.541333 33.802667 54.053334-9.754667 6.026667-111.44 25.173333-173.802667 32.72-61.376 7.424-280.933333 14.069333-325.333333 9.845333z",
                fill: "#9FE0FD",
                "p-id": "1513"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M440 1018.133333c-40.378667-5.765333-114.826667-28.672-148.282667-45.621333-21.76-11.024-25.114667-14.752-22.245333-24.746667 1.850667-6.469333 35.690667-110.88 75.189333-232.026666 50.858667-155.968 74.474667-221.349333 80.912-224 5.002667-2.053333 45.605333-3.738667 90.24-3.738667 65.104 0 82.677333 1.578667 88.928 8C611.306667 502.752 757.333333 942.357333 757.333333 955.386667c0 7.029333-46.805333 28.821333-93.552 43.552-73.765333 23.253333-149.722667 29.76-223.781333 19.194666z m-284-145.418666C128.928 858.224 42.666667 728.533333 42.666667 702.325333c0-10.72 71.253333-73.573333 120.341333-106.154666 36-23.893333 124.981333-68.970667 150.325333-76.154667 7.269333-2.058667 12-1.072 12 2.506667 0 6.202667-115.872 290.72-133.989333 329.002666-12.058667 25.477333-19.258667 29.797333-35.344 21.189334z m686.789333-3.253334c-12.309333-12.314667-10.624-8.506667-85.946666-194.32-32-78.933333-58.176-146.997333-58.176-151.242666 0-27.445333 163.44 60.944 242.453333 131.114666 20.410667 18.133333 38.906667 36.176 41.104 40.101334 8.650667 15.461333-48.906667 114.448-93.776 161.28-25.44 26.549333-30.672 28.048-45.653333 13.061333zM4.282667 554.666667c-1.92-46.197333 1.125333-108.314667 5.882666-120 2.384-5.866667 8.613333-28.666667 13.84-50.666667 5.226667-22 15.482667-53.797333 22.784-70.666667L60.053333 282.666667h180.64C364.394667 282.666667 421.333333 284.448 421.333333 288.32c0 9.552-59.12 151.242667-66.144 158.528-3.632 3.770667-31.84 12.554667-62.682666 19.52-30.842667 6.970667-78.672 20.202667-106.293334 29.397333-50.874667 16.944-169.610667 72.464-176.8 82.672-2.154667 3.061333-4.464-7.637333-5.136-23.770666z m995.717333 18.085333c-112.437333-59.578667-177.845333-84.528-284.4-108.464-24.416-5.488-45.573333-11.146667-47.008-12.586667-4.890667-4.885333-65.925333-153.973333-65.925333-161.018666 0-5.621333 34.858667-7.424 174.666666-9.045334 96.064-1.12 177.776-1.04 181.578667 0.165334 11.44 3.626667 32.154667 50.469333 46.154667 104.352 14.8 56.96 21.472 131.786667 15.146666 169.792l-4.213333 25.28zM437.333333 435.749333c0-14.352 42.864-133.797333 51.402667-143.226666 8.992-9.941333 31.621333-13.013333 42.464-5.776 3.226667 2.154667 8.928 9.717333 12.661333 16.805333 11.285333 21.397333 47.370667 132.773333 44.085334 136.053333-1.68 1.685333-36.256 3.061333-76.837334 3.061334C454.224 442.666667 437.333333 441.082667 437.333333 435.749333zM432 234.026667c-87.424-4.016-160.202667-12.266667-234.666667-26.597334-82.117333-15.808-77.12-12.928-60.442666-34.789333C178.533333 118.042667 290.186667 49.685333 376 26.24c23.466667-6.405333 48-14.106667 54.517333-17.104 16-7.354667 147.146667-7.376 162.602667-0.026667 6.72 3.194667 29.013333 9.941333 49.546667 14.992 45.312 11.146667 126.896 48.512 164.448 75.306667C840.234667 123.045333 901.333333 181.408 901.333333 189.413333c0 7.770667-103.493333 27.386667-194.672 36.906667C614.88 235.893333 526.56 238.368 432 234.026667z",
                fill: "#59E6FD",
                "p-id": "1514"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M440 1018.133333c-40.378667-5.765333-114.826667-28.672-148.282667-45.621333-21.76-11.024-25.114667-14.752-22.245333-24.746667 1.850667-6.469333 35.642667-110.736 75.082667-231.696 68.469333-209.989333 72.373333-220.112 86.245333-223.882666 7.994667-2.170667 48.645333-4 90.346667-4.069334 60.48-0.096 77.381333 1.498667 83.594666 7.882667C611.306667 502.752 757.333333 942.357333 757.333333 955.386667c0 7.029333-46.805333 28.821333-93.552 43.552-73.765333 23.253333-149.722667 29.76-223.781333 19.194666z m-283.669333-145.376c-32.410667-17.733333-119.184-155.253333-110.517334-175.146666 4.714667-10.816 77.813333-72.394667 117.744-99.178667 42.650667-28.608 142.453333-77.296 153.397334-74.826667 5.802667 1.301333-7.333333 39.002667-53.562667 153.728-85.136 211.274667-83.509333 208.309333-107.061333 195.424z m686.458666-3.301333c-12.309333-12.309333-10.624-8.501333-85.946666-194.314667-32-78.933333-58.176-146.997333-58.176-151.242666 0-27.445333 163.44 60.944 242.453333 131.114666 20.410667 18.133333 38.906667 36.176 41.104 40.101334 8.650667 15.461333-48.906667 114.448-93.776 161.28-25.44 26.549333-30.672 28.048-45.653333 13.061333zM6.858667 557.333333c0.042667-14.666667 1.077333-20.032 2.304-11.925333 1.226667 8.106667 1.189333 20.106667-0.074667 26.666667-1.264 6.56-2.266667-0.074667-2.229333-14.741334z m993.141333 15.418667c-112.437333-59.578667-177.845333-84.528-284.4-108.464-24.416-5.488-45.578667-11.157333-47.024-12.597333-6.24-6.24-64.992-160.853333-62.597333-164.736 1.456-2.357333 82.869333-4.288 180.912-4.288h178.261333l13.365333 26.373333c30.117333 59.434667 51.664 187.029333 41.690667 246.906667l-4.208 25.28zM16 544.832c0-16.789333 2.682667-21.429333 17.333333-29.946667 16.736-9.738667 51.653333-31.306667 266.784-164.773333C355.178667 315.952 402.581333 288 405.450667 288c2.869333 0 5.216 3.392 5.216 7.536 0 7.034667-52.037333 147.434667-56.250667 151.770667-1.056 1.088-31.429333 8.624-67.498667 16.746666-86.528 19.498667-138.229333 37.130667-210.917333 71.925334L16 564.704z m424.138667-106.474667c-3.056-3.050667 39.12-124.437333 47.882666-137.802666 8.442667-12.885333 30.352-16.8 44.352-7.930667 6.858667 4.352 54.293333 128.538667 54.293334 142.149333 0 5.264-16.672 6.677333-72.357334 6.117334-39.802667-0.394667-73.173333-1.536-74.170666-2.533334z m128.304-254.912A35758.645333 35758.645333 0 0 1 694.933333 105.621333l52.266667-31.946666 29.418667 14.394666c52.448 25.658667 136.16 100.672 118.448 106.133334-20.026667 6.181333-136.618667 24.928-184.608 29.685333-30.186667 2.997333-91.184 5.445333-135.562667 5.445333H494.213333z",
                fill: "#4DD2FD",
                "p-id": "1515"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M440 1018.133333c-55.664-7.946667-173.333333-49.44-173.333333-61.130666 0-11.808 121.52-373.28 136.101333-404.853334C412.976 530.042667 421.333333 509.562667 421.333333 506.645333c0-2.922667 0.784-5.312 1.738667-5.312 0.96 0 27.84-3.664 59.744-8.144 59.872-8.405333 115.482667-6.250667 124.602667 4.821334 4.8 5.834667 149.914667 448.554667 149.914666 457.376 0 7.029333-46.805333 28.821333-93.552 43.552-73.765333 23.253333-149.722667 29.76-223.781333 19.194666z m-283.669333-145.376c-26.736-14.629333-72.522667-80.736-88.325334-127.541333-8.997333-26.64-9.514667-32.586667-3.328-38.336 4.026667-3.744 43.322667-29.008 87.322667-56.138667 44-27.136 94.309333-58.538667 111.802667-69.792 17.493333-11.253333 32.330667-19.925333 32.981333-19.274666 4.010667 4.005333-39.333333 132.069333-69.610667 205.669333-47.226667 114.805333-48.96 117.386667-70.842666 105.413333z m686.458666-3.301333c-12.309333-12.309333-10.624-8.501333-85.946666-194.314667-32-78.933333-58.176-146.997333-58.176-151.242666 0-27.445333 163.44 60.944 242.453333 131.114666 20.410667 18.133333 38.906667 36.176 41.104 40.101334 8.650667 15.461333-48.906667 114.448-93.776 161.28-25.44 26.549333-30.672 28.048-45.653333 13.061333z m157.210667-296.704c-109.157333-57.84-177.413333-84.245333-274.666667-106.24-19.066667-4.309333-39.866667-9.034667-46.224-10.496-7.797333-1.797333-14.085333-10.037333-19.344-25.338667C651.749333 407.354667 640 360.853333 640 352.448c0-2.602667 21.653333-18.048 48.122667-34.330667l48.128-29.6 114.048-3.722666 114.048-3.722667 13.765333 27.168c30.506667 60.197333 52.133333 187.456 42.096 247.706667l-4.208 25.28zM533.504 432.533333l-23.834667-3.2 26.453334-17.152 26.453333-17.152 9.157333 17.152c14.746667 27.626667 14.997333 27.498667-38.229333 20.352z",
                fill: "#56B1FD",
                "p-id": "1516"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M466.666667 1020.437333c-14.666667-1.098667-31.466667-4.08-37.333334-6.624-5.866667-2.544-25.418667-8.437333-43.456-13.093333-45.173333-11.658667-89.952-28.890667-103.130666-39.690667-11.002667-9.013333-10.858667-9.525333 63.776-232.586666 41.141333-122.949333 75.674667-224.416 76.736-225.477334 5.813333-5.813333 97.6-11.904 135.178666-8.96l43.776 3.424 24.512 72.618667c40.469333 119.893333 125.274667 380.096 125.274667 384.373333 0 6.768-69.909333 35.872-109.333333 45.525334-20.533333 5.024-42.133333 11.146667-48 13.6-12.976 5.418667-91.338667 9.637333-128 6.890666z m378.896-154.304c-4.693333-4.693333-12.282667-17.290667-16.869334-28C804.736 782.186667 704 530.992 704 527.189333c0-6.506667 66.346667 19.573333 106.538667 41.888 56.250667 31.232 95.397333 59.477333 134.464 97.024l36.650666 35.232-15.872 33.2C938.704 791.173333 875.6 874.666667 859.866667 874.666667c-3.173333 0-9.610667-3.84-14.304-8.533334zM134.4 844.64c-25.413333-29.722667-68.512-100.448-73.248-120.181333-3.84-16-7.349333-13.354667 133.52-100.266667 41.066667-25.333333 81.584-50.624 90.032-56.197333l15.365333-10.133334-3.856 13.066667c-6.405333 21.706667-99.712 256.922667-110.437333 278.405333-13.344 26.72-25.472 25.616-51.376-4.693333z m878.88-266.362667c-3.52-7.722667-66.496-40.901333-125.274667-66-48.341333-20.64-141.072-49.157333-182.176-56.016-12.197333-2.032-25.770667-6.528-30.170666-9.978666C667.786667 440.101333 640 368.853333 640 354.869333c0-3.930667 21.845333-20.586667 48.544-37.013333L737.093333 288h227.466667l16.688 43.274667c9.173333 23.802667 19.354667 56.8 22.613333 73.333333 3.258667 16.533333 7.562667 31.258667 9.562667 32.725333 5.706667 4.186667 9.237333 73.738667 5.685333 112-1.770667 19.066667-4.394667 32.090667-5.829333 28.944zM533.509333 432.533333l-23.834666-3.2 26.453333-17.152 26.453333-17.152 9.157334 17.152c14.746667 27.626667 14.997333 27.498667-38.229334 20.352z",
                fill: "#32AEFD",
                "p-id": "1517"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M469.333333 1020.208c-16.133333-0.96-34.133333-3.829333-40-6.384-5.866667-2.549333-26.266667-8.64-45.333333-13.530667-48.928-12.554667-106.666667-39.882667-106.666667-50.490666 0-4.746667 15.098667-51.786667 33.557334-104.544l33.557333-95.925334 29.109333-19.477333c16.010667-10.714667 78.309333-49.813333 138.442667-86.890667l109.333333-67.413333 12.522667 28.224c19.850667 44.757333 118.544 345.930667 115.146667 351.418667-8.16 13.205333-115.770667 52.805333-143.498667 52.805333-6.938667 0-13.413333 2.037333-14.394667 4.528-2.08 5.306667-79.509333 10.186667-121.776 7.68z m379.690667-150.133333C837.194667 862.581333 714.666667 560.826667 714.666667 539.2c0-9.52 10.768-6.837333 59.328 14.784C857.6 591.194667 976 679.237333 976 704.186667c0 23.626667-56.576 114.234667-95.850667 153.509333-18.256 18.256-20.474667 19.136-31.125333 12.384z m165.12-292.261334c-0.997333-7.584-152.586667-82.842667-192.016-95.328-23.728-7.509333-27.322667-10.213333-21.333333-16.032 3.962667-3.850667 46.192-31.04 93.845333-60.421333 98.912-60.986667 90.56-61.365333 107.381333 4.869333 5.194667 20.453333 10.736 35.893333 12.32 34.314667 4.912-4.912 7.781333 67.68 4.106667 104.117333-1.92 19.066667-3.856 31.882667-4.304 28.48z",
                fill: "#2598FD",
                "p-id": "1518"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M472.122667 1019.973333c-22.272-1.109333-34.368-3.605333-30.128-6.224 4.586667-2.832-2.037333-5.653333-18.789334-8.010666-51.482667-7.232-140.629333-43.925333-140.458666-57.813334 0.181333-14.549333-14.736-4.405333 221.253333-150.442666 55.733333-34.490667 112.341333-69.632 125.802667-78.096 13.456-8.464 26.794667-15.386667 29.642666-15.386667 6.544 0 87.221333 228.538667 87.221334 247.082667 0 10.853333-99.568 48.16-145.866667 54.656-17.370667 2.442667-23.509333 5.136-18.666667 8.197333 4.448 2.826667-5.370667 4.597333-25.696 4.650667-18.096 0.042667-36.096 0.789333-40 1.653333-3.909333 0.874667-23.850667 0.746667-44.314666-0.266667z m361.626666-181.306666c-22.074667-49.536-69.818667-173.626667-71.866666-186.773334-1.546667-9.973333 4.672-16.245333 35.258666-35.546666 36.298667-22.906667 37.509333-23.253333 53.333334-15.221334 27.52 13.962667 79.061333 52.730667 103.285333 77.690667l23.093333 23.792-17.157333 34.026667C927.253333 800.997333 874.005333 869.333333 856.32 869.333333c-5.706667 0-13.824-11.029333-22.570667-30.666666z m178.88-282.666667c-0.624-22.634667-1.050667-23.472-4-7.850667l-3.296 17.482667-31.066666-19.477333-31.066667-19.477334 31.024-20.602666c27.226667-18.08 31.434667-19.466667 34.4-11.338667 2.762667 7.568 3.856 6.821333 5.984-4.069333 1.434667-7.333333 2.933333 10.064 3.333333 38.666666 0.4 28.597333-0.474667 52-1.941333 52s-2.986667-11.402667-3.370667-25.333333z",
                fill: "#1585FD",
                "p-id": "1519"
            })
        ]
    });
};
/* harmony default export */ var banner_AtomGitSvg = (AtomGitSvg);

// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 3 modules
var polished_esm = __webpack_require__(43281);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/antd/es/carousel/index.js + 9 modules
var carousel = __webpack_require__(61980);
// EXTERNAL MODULE: ./packages/ui/src/styled.ts
var styled = __webpack_require__(78763);
// EXTERNAL MODULE: ./packages/ui/src/colors.ts
var colors = __webpack_require__(22745);
// EXTERNAL MODULE: ./packages/ui/src/mixins.ts
var mixins = __webpack_require__(52873);
;// CONCATENATED MODULE: ./src/pages/talent-plan/banner/banner.styled.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    color: ",
        ";\n    padding: 0;\n    background: url(",
        ");\n    background-size: cover;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      padding: 0 0 5.5rem;\n\n      ",
        " {\n        width: 80%;\n        text-align: center;\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  height: 100%;\n  width: 100%;\n  padding: 5rem 1rem;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    ",
        ";\n    font-size: 16px;\n    color: ",
        ";\n    font-weight: normal;\n    margin-bottom: 2rem;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    font-size: 30px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  padding-top: 2.5rem;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          justify-content: center;\n          height: 100%;\n          width: 100%;\n        "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n          margin-top: 2rem;\n        "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n    margin-bottom: 3rem;\n\n    .slick-slide {\n      padding-right: 0;\n    }\n\n    .slick-dots {\n      margin: 0 auto;\n      bottom: -32px;\n\n      li {\n        margin: 3px 8px;\n\n        &,\n        button {\n          ",
        "\n        }\n\n        &.slick-active {\n          &,\n          button {\n            ",
        "\n          }\n        }\n      }\n    }\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n\n  .slick-slide {\n    padding-right: 1.5rem;\n    cursor: pointer;\n  }\n\n  .slick-track {\n    height: auto !important;\n  }\n\n  .slick-dots {\n    li {\n      margin: 8px 3px;\n\n      &,\n      button {\n        ",
        "\n        background: ",
        ";\n        border-radius: 3px;\n      }\n\n      &.slick-active {\n        &,\n        button {\n          ",
        "\n          background: ",
        ";\n        }\n      }\n    }\n  }\n}\n\n",
        "\n\n;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0 auto;\n  height: ",
        ";\n  background: ",
        ";\n  background-size: contain;\n  position: relative;\n  width: 110%;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}





var Container = (0,styled_components_browser_esm/* default */.ZP)(styled/* Section */.$0)(_templateObject(), colors.F1, getImage("banner-background.svg"));
var Content = (0,styled_components_browser_esm/* default */.ZP)(styled/* Content */.VY)(_templateObject2(), function(props) {
    return props.isSmallScreen && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), Intro);
});
var Intro = styled_components_browser_esm/* default.h2 */.ZP.h2(_templateObject3(), mixins/* reset */.mc(), colors.F1);
var Title = styled_components_browser_esm/* default.h1 */.ZP.h1(_templateObject4());
var LeftPanel = styled_components_browser_esm/* default.div */.ZP.div(_templateObject5());
// vertically center the carousel
var CarouselWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject8(), function(props) {
    return props.isSmallScreen ? (0,styled_components_browser_esm/* css */.iv)(_templateObject6()) : (0,styled_components_browser_esm/* css */.iv)(_templateObject7());
});
var Carousel = (0,styled_components_browser_esm/* default */.ZP)(carousel/* default */.Z).attrs(function(props) {
    return {
        dotPosition: props.isSmallScreen ? "bottom" : "right",
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 4000
    };
})(_templateObject10(), mixins/* size */.dp("6px", "40px"), polished_esm/* rgba */.m4(colors.F2, 0.1), mixins/* size */.dp("6px", "50px"), polished_esm/* rgba */.m4(colors.F2, 0.3), function(props) {
    return props.isSmallScreen && (0,styled_components_browser_esm/* css */.iv)(_templateObject9(), mixins/* size */.dp("40px", "6px"), mixins/* size */.dp("50px", "6px"));
});
var Recommendation = styled_components_browser_esm/* default.div */.ZP.div(_templateObject11(), function(props) {
    return "".concat(props.height, "px");
}, function(props) {
    return "url(".concat(props.image, ") center no-repeat");
});

;// CONCATENATED MODULE: ./src/pages/talent-plan/banner/Banner.component.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}










var AtomGitIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, _objectSpread({
        component: banner_AtomGitSvg
    }, props));
};
var Banner = function() {
    var ref = (0,useIsSmallScreen/* default */.Z)(), isSmallScreen = ref.isSmallScreen, breakpoint = ref.breakpoint;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(twoColumnsSection/* default */.Z, {
                leftPanel: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeftPanel, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            children: "Talent Plan"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Intro, {
                            children: "\u4EE5 Talent Plan \u5F00\u6E90\u6570\u636E\u5E93\u5F00\u53D1\u8BFE\u7A0B\u4E3A\u4F9D\u6258\uFF0C\u8054\u5408\u4F18\u79C0\u9AD8\u6821\u548C\u4F01\u4E1A\uFF0C\u5EFA\u8BBE\u6210\u5BF9\u5168\u56FD\u5404\u9AD8\u6821\u6570\u636E\u5E93\u5F00\u53D1\u4EBA\u624D\u57F9\u517B\u7684\u6700\u4F73\u5B9E\u8DF5\u5E73\u53F0\u3002\u65E2\u80FD\u5E2E\u52A9\u5B66\u4E60\u8005\u638C\u63E1\u6570\u636E\u5E93\u5F00\u53D1\u7684\u7406\u8BBA\u77E5\u8BC6\uFF0C\u8FDB\u884C\u5B9E\u9645\u6570\u636E\u5E93\u5F00\u53D1\u953B\u70BC\uFF0C\u53C8\u80FD\u7ED9\u4E0E\u5B66\u4E60\u8005\u4F7F\u7528\u5F00\u6E90\u8D44\u6E90\uFF0C\u5F00\u53D1\u5F00\u6E90\u8F6F\u4EF6\u7684\u57F9\u517B\u3002"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(space/* default */.Z, {
                            size: 24,
                            wrap: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                    href: "https://github.com/pingcap/talent-plan",
                                    style: {
                                        fontSize: 24
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                        type: "text",
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(GithubOutlined/* default */.Z, {}),
                                        children: "Github \u5165\u53E3"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                    href: "https://atomgit.com/pingcap/talent-plan#/",
                                    style: {
                                        fontSize: 24
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                        type: "text",
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomGitIcon, {}),
                                        children: "AtomGit \u5165\u53E3"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                    href: "mailto:talent-plan@tidb.io",
                                    style: {
                                        fontSize: 24
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                                        title: "Email: talent-plan@tidb.io",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                            type: "text",
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(MailOutlined/* default */.Z, {}),
                                            children: "\u8054\u7CFB\u6211\u4EEC"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                rightPanel: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel, {
                        isSmallScreen: isSmallScreen,
                        children: [
                            1,
                            2,
                            3
                        ].map(function(el) {
                            var props = {
                                image: getImage("banner-rec-".concat(el, ".svg")),
                                key: el,
                                height: function() {
                                    if (breakpoint.lg) {
                                        return 300;
                                    }
                                    if (breakpoint.md) {
                                        return 300;
                                    }
                                    if (breakpoint.sm) {
                                        return 300;
                                    }
                                    if (breakpoint.xs) {
                                        return 200;
                                    }
                                }()
                            };
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Recommendation, _objectSpread({}, props));
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ var Banner_component = (Banner);

;// CONCATENATED MODULE: ./src/pages/talent-plan/banner/index.js


// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
;// CONCATENATED MODULE: ./src/pages/talent-plan/institutes/institutes.styled.js
function institutes_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function institutes_styled_templateObject() {
    var data = institutes_styled_taggedTemplateLiteral([
        "\n  && {\n    color: ",
        ";\n    padding: 0;\n  }\n"
    ]);
    institutes_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function institutes_styled_templateObject1() {
    var data = institutes_styled_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    institutes_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function institutes_styled_templateObject2() {
    var data = institutes_styled_taggedTemplateLiteral([
        "\n  box-shadow: 1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);\n  border-radius: 4px;\n  background-color: ",
        ";\n  padding: 48px;\n  height: 100%;\n"
    ]);
    institutes_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function institutes_styled_templateObject3() {
    var data = institutes_styled_taggedTemplateLiteral([
        "\n  font-size: 16px;\n  color: ",
        ";\n  line-height: 2.5;\n  vertical-align: middle;\n\n  &:before {\n    vertical-align: middle;\n    background-size: 24px 24px;\n    height: 24px;\n    width: 24px;\n    display: inline-block;\n    content: '  ';\n    background-image: url('",
        "');\n  }\n"
    ]);
    institutes_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function institutes_styled_templateObject4() {
    var data = institutes_styled_taggedTemplateLiteral([
        "\n  .slick-dots {\n    li {\n      &,\n      button {\n        ",
        "\n        background: ",
        ";\n        border-radius: 4px;\n      }\n\n      &.slick-active {\n        &,\n        button {\n          ",
        "\n          background: ",
        ";\n        }\n      }\n    }\n  }\n"
    ]);
    institutes_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function institutes_styled_templateObject5() {
    var data = institutes_styled_taggedTemplateLiteral([
        "\n  padding-bottom: 3rem;\n  padding-right: 0.2rem;\n  padding-left: 0.2rem;\n"
    ]);
    institutes_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





var institutes_styled_Container = (0,styled_components_browser_esm/* default */.ZP)(styled/* Section */.$0)(institutes_styled_templateObject(), colors.M1);
var institutes_styled_Content = (0,styled_components_browser_esm/* default */.ZP)(styled/* Content */.VY)(institutes_styled_templateObject1());
var ListCard = styled_components_browser_esm/* default.div */.ZP.div(institutes_styled_templateObject2(), colors.M2);
var ListItem = styled_components_browser_esm/* default.div */.ZP.div(institutes_styled_templateObject3(), colors.F1, getImage("institutes-item-icon.svg"));
var institutes_styled_Carousel = (0,styled_components_browser_esm/* default */.ZP)(carousel/* default */.Z).attrs({
    autoplay: true,
    autoplaySpeed: 4000
})(institutes_styled_templateObject4(), mixins/* size */.dp("8px", "8px"), polished_esm/* rgba */.m4(colors.F2, 0.3), mixins/* size */.dp("8px", "8px"), polished_esm/* rgba */.m4(colors.F2, 0.5));
var CarouselContent = styled_components_browser_esm/* default.div */.ZP.div(institutes_styled_templateObject5());

;// CONCATENATED MODULE: ./src/pages/talent-plan/institutes/Institutes.component.js






var universityNames = [
    "\u52A0\u5DDE\u5927\u5B66",
    "\u534E\u4E2D\u79D1\u6280\u5927\u5B66",
    "\u4E2D\u56FD\u79D1\u5B66\u6280\u672F\u5927\u5B66",
    "\u534E\u4E1C\u5E08\u8303\u5927\u5B66",
    "\u5357\u5F00\u5927\u5B66",
    "\u7535\u5B50\u79D1\u6280\u5927\u5B66",
    "\u5317\u4EAC\u90AE\u7535\u5927\u5B66",
    "\u4E0A\u6D77\u4EA4\u901A\u5927\u5B66",
    "\u6D59\u6C5F\u5927\u5B66",
    "\u5317\u4EAC\u822A\u7A7A\u822A\u5929\u5927\u5B66",
    "\u6B66\u6C49\u5927\u5B66",
    "\u5E7F\u4E1C\u5DE5\u4E1A\u5927\u5B66",
    "\u5317\u4EAC\u5927\u5B66",
    "\u590D\u65E6\u5927\u5B66",
    "\u534E\u5357\u7406\u5DE5\u5927\u5B66",
    "\u5BBE\u5DDE\u5DDE\u7ACB\u5927\u5B66",
    "\u5409\u6797\u5927\u5B66",
    "\u4E9A\u741B\u5DE5\u4E1A\u5927\u5B66",
    "\u6FB3\u5927\u5229\u4E9A\u56FD\u7ACB\u5927\u5B66",
    "\u65E9\u7A3B\u7530\u5927\u5B66",
    "\u5927\u8FDE\u7406\u5DE5\u5927\u5B66",
    "\u4E1C\u5357\u5927\u5B66",
    "\u56DB\u5DDD\u5927\u5B66",
    "\u897F\u5B89\u4EA4\u901A\u5927\u5B66",
    "\u5357\u4EAC\u5927\u5B66",
    "\u6E05\u534E\u5927\u5B66",
    "\u897F\u5317\u5DE5\u4E1A\u5927\u5B66",
    "\u4E2D\u56FD\u79D1\u5B66\u9662\u5927\u5B66",
    "\u4E2D\u5C71\u5927\u5B66",
    "\u540C\u6D4E\u5927\u5B66",
    "\u54C8\u5C14\u6EE8\u5DE5\u4E1A\u5927\u5B66",
    "\u5317\u4EAC\u79D1\u6280\u5927\u5B66",
    "\u4E1C\u5317\u5927\u5B66",
    "\u6DF1\u5733\u5927\u5B66",
    "\u6842\u6797\u7535\u5B50\u79D1\u6280\u5927\u5B66",
    "\u5C71\u4E1C\u5927\u5B66",
    "\u96EA\u57CE\u5927\u5B66",
    "\u829D\u52A0\u54E5\u5927\u5B66",
    "\u5929\u6D25\u5927\u5B66",
    "\u5361\u5185\u57FA\u6885\u9686\u5927\u5B66",
    "\u5317\u4EAC\u7406\u5DE5\u5927\u5B66",
    "\u4E54\u6CBB\u4E9A\u7406\u5DE5\u5927\u5B66",
    "\u4FC4\u4EA5\u4FC4\u5DDE\u7ACB\u5927\u5B66",
    "\u5357\u52A0\u5229\u798F\u5229\u4E9A\u5927\u5B66",
    "\u65B0\u5357\u5A01\u5C14\u58EB\u5927\u5B66",
    "\u4F0A\u5229\u8BFA\u4F0A\u5927\u5B66",
    "\u745E\u5178\u7687\u5BB6\u7406\u5DE5\u5927\u5B66",
    "\u4E0D\u5217\u98A0\u54E5\u4F26\u6BD4\u4E9A\u5927\u5B66",
    "\u7231\u4E01\u5821\u5927\u5B66",
    "\u5317\u5361\u7F57\u6765\u7EB3\u5927\u5B66",
    "\u675C\u514B\u5927\u5B66",
    "\u8D6B\u5C14\u8F9B\u57FA\u5927\u5B66",
    "\u82CF\u9ECE\u4E16\u8054\u90A6\u7406\u5DE5\u5927\u5B66",
    "\u58A8\u5C14\u672C\u7687\u5BB6\u7406\u5DE5\u5927\u5B66",
    "\u53F0\u6E7E\u5927\u5B66",
    "\u5A01\u65AF\u5EB7\u8F9B\u5927\u5B66",
    "\u4F50\u6CBB\u4E9A\u7406\u5DE5\u5B66\u9662",
    "\u5357\u6D0B\u7406\u5DE5\u5927\u5B66",
    "\u65B0\u52A0\u5761\u56FD\u7ACB\u5927\u5B66",
    "\u5357\u52A0\u5DDE\u5927\u5B66", 
];
var Institutes = function() {
    var isSmallScreen = (0,useIsSmallScreen/* default */.Z)().isSmallScreen;
    var MAX_LIST_ITEMS = 10;
    // split list into chunks of 15
    var chunks = [];
    for(var i = 0; i < universityNames.length; i += MAX_LIST_ITEMS){
        chunks.push(universityNames.slice(i, i + MAX_LIST_ITEMS));
    }
    var PAGE_SIZE = isSmallScreen ? 1 : 3;
    var pages = [];
    for(var i1 = 0; i1 < chunks.length; i1 += PAGE_SIZE){
        pages.push(chunks.slice(i1, i1 + PAGE_SIZE));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(institutes_styled_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(institutes_styled_Content, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Title */.Dx, {
                    children: "\u4E2A\u4EBA\u5B66\u4E60\u8005\u6765\u6E90"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(institutes_styled_Carousel, {
                    children: pages.map(function(page) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselContent, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                                gutter: 16,
                                children: page.map(function(chunk) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                        span: isSmallScreen ? 24 : 8,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListCard, {
                                            children: chunk.map(function(name) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem, {
                                                    children: [
                                                        " ",
                                                        name,
                                                        " "
                                                    ]
                                                }, name);
                                            })
                                        })
                                    }, chunk[0]);
                                })
                            })
                        });
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Institutes_component = (Institutes);

;// CONCATENATED MODULE: ./src/pages/talent-plan/institutes/index.js


// EXTERNAL MODULE: ./node_modules/antd/es/image/index.js + 22 modules
var es_image = __webpack_require__(44458);
;// CONCATENATED MODULE: ./src/pages/talent-plan/labs/labs.styled.js
function labs_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function labs_styled_templateObject() {
    var data = labs_styled_taggedTemplateLiteral([
        "\n  && {\n    padding: 0;\n  }\n"
    ]);
    labs_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function labs_styled_templateObject1() {
    var data = labs_styled_taggedTemplateLiteral([
        "\n  position: relative;\n  padding-top: 3rem;\n  padding-bottom: 3rem;\n"
    ]);
    labs_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function labs_styled_templateObject2() {
    var data = labs_styled_taggedTemplateLiteral([
        "\n  height: 100px;\n  ",
        "\n  border-radius: 4px;\n  background-color: ",
        ";\n  padding: 1rem;\n  margin-bottom: 1rem;\n\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    labs_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function labs_styled_templateObject3() {
    var data = labs_styled_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    labs_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function labs_styled_templateObject4() {
    var data = labs_styled_taggedTemplateLiteral([
        "\n  && {\n    text-align: center;\n    color: ",
        ";\n  }\n"
    ]);
    labs_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function labs_styled_templateObject5() {
    var data = labs_styled_taggedTemplateLiteral([
        "\n  width: 100%;\n  align-items: center;\n"
    ]);
    labs_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var labs_styled_Container = (0,styled_components_browser_esm/* default */.ZP)(styled/* Section */.$0)(labs_styled_templateObject());
var labs_styled_Content = (0,styled_components_browser_esm/* default */.ZP)(styled/* Content */.VY)(labs_styled_templateObject1());
var LabCard = styled_components_browser_esm/* default.div */.ZP.div(labs_styled_templateObject2(), mixins/* boxShadow */.Wn(), colors.M2);
var LabCardImgWrapper = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z)(labs_styled_templateObject3());
var LabCardTitle = styled_components_browser_esm/* default.div */.ZP.div(labs_styled_templateObject4(), colors.F1);
var Row = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z)(labs_styled_templateObject5());

;// CONCATENATED MODULE: ./src/pages/talent-plan/labs/Labs.component.js






var orgs = [
    {
        img: "/images/talent-plan/labs-logo-3.png",
        name: "\u534E\u4E2D\u79D1\u6280\u5927\u5B66\u56FD\u5BB6\u5149\u7535\u5B9E\u9A8C\u5BA4\u5E76\u884C\u6570\u636E\u5B9E\u9A8C\u5BA4"
    },
    {
        img: "/images/talent-plan/labs-logo-6.png",
        name: "\u4E2D\u56FD\u79D1\u5B66\u6280\u672F\u5927\u5B66 ADSL \u5B9E\u9A8C\u5BA4"
    },
    {
        img: "/images/talent-plan/labs-logo-4.png",
        name: "\u5357\u5F00\u5927\u5B66\u6570\u636E\u5E93\u5B9E\u9A8C\u5BA4"
    },
    {
        img: "/images/talent-plan/labs-logo-1.png",
        name: "\u7535\u5B50\u79D1\u6280\u5927\u5B66\u8BA1\u7B97\u673A\u79D1\u5B66\u4E0E\u5DE5\u7A0B\u5B66\u9662"
    },
    {
        img: "/images/talent-plan/labs-logo-2.png",
        name: "\u534E\u4E1C\u5E08\u8303\u5927\u5B66\u6570\u636E\u79D1\u5B66\u4E0E\u5DE5\u7A0B\u5B66\u9662"
    },
    {
        img: "/images/talent-plan/labs-logo-5.png",
        name: "\u4EBA\u6C11\u5927\u5B66\u4FE1\u606F\u5B66\u9662"
    }, 
];
var Labs = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(labs_styled_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(labs_styled_Content, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Title */.Dx, {
                    children: "\u8C01\u5728\u4F7F\u7528\u6211\u4EEC\u7684\u9879\u76EE"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                    gutter: 16,
                    children: orgs.map(function(org) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                            lg: 8,
                            md: 12,
                            xs: 24,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabCard, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                                    gutter: 4,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LabCardImgWrapper, {
                                            span: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_image/* default */.Z, {
                                                preview: false,
                                                src: utils/* cdn.getImageUrl */.cK.getImageUrl(org.img)
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                            span: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LabCardTitle, {
                                                children: [
                                                    " ",
                                                    org.name,
                                                    " "
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        }, org.name);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Labs_component = (Labs);

;// CONCATENATED MODULE: ./src/pages/talent-plan/labs/index.js


// EXTERNAL MODULE: ./node_modules/antd/es/avatar/index.js + 3 modules
var avatar = __webpack_require__(24093);
;// CONCATENATED MODULE: ./src/pages/talent-plan/team/team.styled.js
function team_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function team_styled_templateObject() {
    var data = team_styled_taggedTemplateLiteral([
        "\n  && {\n    color: ",
        ";\n    padding: 0;\n  }\n"
    ]);
    team_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function team_styled_templateObject1() {
    var data = team_styled_taggedTemplateLiteral([
        "\n  padding-bottom: 1rem;\n"
    ]);
    team_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function team_styled_templateObject2() {
    var data = team_styled_taggedTemplateLiteral([
        "\n  ",
        "\n  border-radius: 4px;\n  background-color: ",
        ";\n  padding: 1rem;\n  height: 100%;\n  display: flex;\n"
    ]);
    team_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function team_styled_templateObject3() {
    var data = team_styled_taggedTemplateLiteral([
        "\n  min-width: 48px;\n"
    ]);
    team_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function team_styled_templateObject4() {
    var data = team_styled_taggedTemplateLiteral([
        "\n  margin-left: 1rem;\n  color: ",
        ";\n"
    ]);
    team_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function team_styled_templateObject5() {
    var data = team_styled_taggedTemplateLiteral([
        "\n  font-weight: bold;\n"
    ]);
    team_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function team_styled_templateObject6() {
    var data = team_styled_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 12px;\n  font-weight: normal;\n  word-wrap: break-word;\n  ",
        "\n  \n  // disable line-clamp on hover\n  &:hover {\n    overflow: visible;\n    ",
        "\n  \n"
    ]);
    team_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function team_styled_templateObject7() {
    var data = team_styled_taggedTemplateLiteral([
        "\n  position: relative;\n  padding-bottom: 3rem;\n"
    ]);
    team_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var team_styled_Container = (0,styled_components_browser_esm/* default */.ZP)(styled/* Section */.$0)(team_styled_templateObject(), colors.M1);
var CardWrapper = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z)(team_styled_templateObject1());
var MemberCard = styled_components_browser_esm/* default.div */.ZP.div(team_styled_templateObject2(), mixins/* boxShadow */.Wn(), colors.M2);
var MemberCardAvatar = (0,styled_components_browser_esm/* default */.ZP)(avatar/* default */.C)(team_styled_templateObject3());
var MemberCardContent = styled_components_browser_esm/* default.div */.ZP.div(team_styled_templateObject4(), colors.F1);
var MemberCardHeader = styled_components_browser_esm/* default.div */.ZP.div(team_styled_templateObject5());
var MemberCardLine = styled_components_browser_esm/* default.div */.ZP.div(team_styled_templateObject6(), colors.F2, mixins/* lineClamp */.Sf(1), mixins/* lineClamp */.Sf(2));
var team_styled_Content = (0,styled_components_browser_esm/* default */.ZP)(styled/* Content */.VY)(team_styled_templateObject7());

;// CONCATENATED MODULE: ./src/pages/talent-plan/team/Team.component.js






var members = [
    {
        nameEN: "Jiguang Wang",
        nameZH: "\u4E07\u7EE7\u5149",
        org: "\u534E\u4E2D\u79D1\u6280\u5927\u5B66",
        role: "PMC"
    },
    {
        nameEN: "Karim",
        nameZH: "\u6C5F\u5764",
        org: "Digital China",
        role: "PMC",
        github: "pupillord"
    },
    {
        nameEN: "Xiaoguang Sun",
        nameZH: "\u5B59\u6653\u5149",
        org: "PingCAP",
        role: "PMC",
        github: "sunxiaoguang"
    },
    {
        nameEN: "Jian Zhang",
        nameZH: "\u5F20\u5EFA",
        role: "PMC",
        github: "zz-jason"
    },
    {
        nameEN: "Junyi Yang",
        nameZH: "\u6768\u4FCA\u9038",
        org: "PingCAP",
        role: "Committer",
        github: "rebelice"
    },
    {
        nameEN: "Connor",
        nameZH: "\u5F20\u535A\u5EB7",
        org: "PingCAP",
        role: "Committer",
        github: "Connor1996"
    },
    {
        nameEN: "Xiang Zhang",
        nameZH: "\u5F20\u7FD4",
        org: "PingCAP",
        role: "Committer",
        github: "zhangyangyu"
    },
    {
        nameEN: "David",
        nameZH: "\u6768\u8FD0\u5E37",
        org: "Digital China",
        role: "Active Contributor",
        github: "AmoebaProtozoa"
    },
    {
        nameEN: "xurui",
        nameZH: "\u5F90\u9510",
        org: "oltp group",
        role: "Senior Mentor",
        github: "cfzjywxk"
    },
    {
        nameEN: "Tong Mu",
        nameZH: "\u7AE5\u7267",
        org: "PingCAP",
        role: "Senior Mentor",
        github: "you06"
    },
    {
        nameEN: "Cui Yiding",
        nameZH: "\u5D14\u4E00\u4E01",
        org: "PingCAP",
        role: "Senior Mentor",
        github: "winoros"
    },
    {
        nameEN: "Andy",
        nameZH: "\u9A86\u8FEA\u5B89",
        role: "Senior Mentor",
        github: "andylokandy"
    },
    {
        nameEN: "Panda",
        nameZH: "\u738B\u80FD\u6770",
        org: "\u534E\u4E2D\u79D1\u6280\u5927\u5B66",
        role: "Mentor",
        github: "wangnengjie"
    },
    {
        nameEN: "Hammer Li",
        nameZH: "\u674E\u601D\u5C91",
        org: "\u534E\u4E2D\u79D1\u6280\u5927\u5B66",
        role: "Mentor",
        github: "L\u2013LYR"
    },
    {
        nameEN: "Chen Jingang",
        nameZH: "\u9648\u52B2\u521A",
        org: "\u534E\u4E2D\u79D1\u6280\u5927\u5B66",
        role: "Mentor",
        github: "Whorra"
    },
    {
        nameEN: "Li Xiang",
        nameZH: "\u674E\u54CD",
        org: "\u534E\u4E2D\u79D1\u6280\u5927\u5B66",
        role: "Mentor",
        github: "LX-676655103"
    },
    {
        nameEN: "Zhang Jiakun",
        nameZH: "\u5F20\u5BB6\u5764",
        org: "\u4E2D\u56FD\u79D1\u5B66\u6280\u672F\u5927\u5B66",
        role: "Mentor",
        github: "JK1Zhang"
    },
    {
        nameEN: "Zhang Qingyang",
        nameZH: "\u5F20\u64CE\u6D0B",
        org: "\u4E2D\u56FD\u79D1\u5B66\u6280\u672F\u5927\u5B66",
        role: "Mentor",
        github: "QingyangZ"
    },
    {
        nameEN: "Li Xing",
        nameZH: "\u674E\u946B",
        org: "\u7535\u5B50\u79D1\u6280\u5927\u5B66",
        role: "Mentor",
        github: "oocococo"
    },
    {
        nameEN: "Tang Ruilin",
        nameZH: "\u6C64\u745E\u9E9F",
        org: "\u534E\u4E2D\u79D1\u6280\u5927\u5B66",
        role: "Mentor",
        github: "Tangruilin"
    },
    {
        nameEN: "Hu Yu",
        nameZH: "\u80E1\u715C",
        org: "\u6D59\u6C5F\u5927\u5B66",
        role: "Mentor",
        github: "charstal"
    },
    {
        nameEN: "Tan Xinyu",
        nameZH: "\u8C2D\u65B0\u5B87",
        org: "\u6E05\u534E\u5927\u5B66",
        role: "Mentor",
        github: "OneSizeFitsQuorum"
    },
    {
        nameEN: "Tan Shun",
        nameZH: "\u8C2D\u987A",
        org: "\u5C71\u897F\u5927\u5B66",
        role: "Mentor",
        github: "madao756"
    },
    {
        nameEN: "Huang Zhanghen",
        nameZH: "\u9EC4\u7AE0\u8861",
        org: "\u798F\u5DDE\u5927\u5B66",
        role: "Mentor",
        github: "hzh0425"
    }, 
];
var Team = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(team_styled_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(team_styled_Content, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Title */.Dx, {
                    children: "\u6211\u4EEC\u7684\u56E2\u961F"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                    gutter: 16,
                    children: members.map(function(member) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardWrapper, {
                            lg: 6,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MemberCard, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MemberCardAvatar, {
                                        size: 48,
                                        src: getImage("team-".concat(member.nameZH, ".jpg"))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MemberCardContent, {
                                        children: [
                                            member.nameZH && /*#__PURE__*/ (0,jsx_runtime.jsx)(MemberCardHeader, {
                                                children: member.nameZH
                                            }),
                                            member.org && /*#__PURE__*/ (0,jsx_runtime.jsxs)(MemberCardLine, {
                                                children: [
                                                    "Org: ",
                                                    member.org
                                                ]
                                            }),
                                            member.role && /*#__PURE__*/ (0,jsx_runtime.jsxs)(MemberCardLine, {
                                                children: [
                                                    "Role: ",
                                                    member.role
                                                ]
                                            }),
                                            member.github && /*#__PURE__*/ (0,jsx_runtime.jsxs)(MemberCardLine, {
                                                children: [
                                                    "GitHub: ",
                                                    member.github
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, member.nameEN);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Team_component = (Team);

;// CONCATENATED MODULE: ./src/pages/talent-plan/team/index.js


// EXTERNAL MODULE: ./node_modules/antd/es/tabs/index.js + 17 modules
var tabs = __webpack_require__(87961);
;// CONCATENATED MODULE: ./src/pages/talent-plan/participation/partitcipation.styled.js
function partitcipation_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function partitcipation_styled_templateObject() {
    var data = partitcipation_styled_taggedTemplateLiteral([
        "\n  margin: 4rem 0;\n  && {\n    color: ",
        ";\n    padding: 0;\n  }\n"
    ]);
    partitcipation_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function partitcipation_styled_templateObject1() {
    var data = partitcipation_styled_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    partitcipation_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function partitcipation_styled_templateObject2() {
    var data = partitcipation_styled_taggedTemplateLiteral([
        "\n  && {\n    background-color: ",
        ";\n    color: ",
        ";\n    padding: 0;\n  }\n\n  ",
        " {\n    padding-top: 2rem;\n  }\n"
    ]);
    partitcipation_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function partitcipation_styled_templateObject3() {
    var data = partitcipation_styled_taggedTemplateLiteral([
        "\n  // icon before the div\n  &:before {\n    content: '';\n    display: block;\n    background: url(",
        ") no-repeat;\n    width: 32px;\n    height: 32px;\n    flex: 0 0 2em;\n  }\n\n  display: flex;\n  align-items: flex-start;\n  margin-left: 1rem;\n  margin-bottom: 1rem;\n"
    ]);
    partitcipation_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function partitcipation_styled_templateObject4() {
    var data = partitcipation_styled_taggedTemplateLiteral([
        "\n  margin-left: 1rem;\n"
    ]);
    partitcipation_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function partitcipation_styled_templateObject5() {
    var data = partitcipation_styled_taggedTemplateLiteral([
        "\n  padding-top: 1rem;\n"
    ]);
    partitcipation_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function partitcipation_styled_templateObject6() {
    var data = partitcipation_styled_taggedTemplateLiteral([
        "\n  font-size: 20px;\n  font-weight: 500;\n"
    ]);
    partitcipation_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function partitcipation_styled_templateObject7() {
    var data = partitcipation_styled_taggedTemplateLiteral([
        "\n  padding-bottom: 1rem;\n  // PM says the all the cards should be the same height...\n  // ...so we need to set the height of the card here\n  position: relative;\n"
    ]);
    partitcipation_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function partitcipation_styled_templateObject8() {
    var data = partitcipation_styled_taggedTemplateLiteral([
        "\n  text-decoration: none !important;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);\n  border-radius: 4px;\n  background-color: ",
        ";\n\n  cursor: pointer;\n  height: 100%;\n\n  padding: 1.5rem 1.5rem 1.5rem calc(1.5rem - 4px);\n  border-left: 4px solid ",
        ";\n\n  &:hover {\n    border-left: 4px solid ",
        ";\n  }\n"
    ]);
    partitcipation_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function partitcipation_styled_templateObject9() {
    var data = partitcipation_styled_taggedTemplateLiteral([
        "\n  font-size: 18px;\n  color: ",
        ";\n  padding-bottom: 1rem;\n"
    ]);
    partitcipation_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function partitcipation_styled_templateObject10() {
    var data = partitcipation_styled_taggedTemplateLiteral([
        "\n  // icon before the div\n  &:before {\n    content: '';\n    display: block;\n    background: url(",
        ") no-repeat;\n    width: 24px;\n    height: 24px;\n    flex: 0 0 2em;\n  }\n\n  display: flex;\n  align-items: flex-start;\n  margin-left: 1rem;\n  margin-bottom: 1rem;\n"
    ]);
    partitcipation_styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function partitcipation_styled_templateObject11() {
    var data = partitcipation_styled_taggedTemplateLiteral([
        "\n  font-size: 16px;\n  padding-bottom: 1rem;\n"
    ]);
    partitcipation_styled_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = partitcipation_styled_taggedTemplateLiteral([
        "\n  margin-left: 0.5rem;\n  font-size: 14px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = partitcipation_styled_taggedTemplateLiteral([
        "\n      display: grid;\n    "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = partitcipation_styled_taggedTemplateLiteral([
        "\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  ",
        ";\n  padding-bottom: 1rem;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = partitcipation_styled_taggedTemplateLiteral([
        "\n  color: #2c2c2c;\n  li {\n    font-size: 16px;\n  }\n  a {\n    color: ",
        ";\n    :hover {\n      text-decoration: underline;\n    }\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}



var partitcipation_styled_Container = (0,styled_components_browser_esm/* default */.ZP)(styled/* Section */.$0)(partitcipation_styled_templateObject(), colors.M1);
var partitcipation_styled_Content = (0,styled_components_browser_esm/* default */.ZP)(styled/* Content */.VY)(partitcipation_styled_templateObject1());
var ContainerGray = (0,styled_components_browser_esm/* default */.ZP)(styled/* Section */.$0)(partitcipation_styled_templateObject2(), colors.M2, colors.F1, partitcipation_styled_Content);
var StepBox = styled_components_browser_esm/* default.div */.ZP.div(partitcipation_styled_templateObject3(), function(props) {
    return props.icon;
});
var StepBoxInner = styled_components_browser_esm/* default.div */.ZP.div(partitcipation_styled_templateObject4());
var StepBoxContent = styled_components_browser_esm/* default.div */.ZP.div(partitcipation_styled_templateObject5());
var StepBoxHeader = styled_components_browser_esm/* default.div */.ZP.div(partitcipation_styled_templateObject6());
var PathCardWrapper = styled_components_browser_esm/* default.div */.ZP.div(partitcipation_styled_templateObject7());
var PathCard = styled_components_browser_esm/* default.div */.ZP.div(partitcipation_styled_templateObject8(), colors.M2, colors.M2, colors.B1);
var PathCardHeader = styled_components_browser_esm/* default.div */.ZP.div(partitcipation_styled_templateObject9(), colors.B1);
var BecomingBox = styled_components_browser_esm/* default.div */.ZP.div(partitcipation_styled_templateObject10(), getImage("participation-step-icon-1.svg"));
var BecomingHeader = styled_components_browser_esm/* default.div */.ZP.div(partitcipation_styled_templateObject11());
var BecomingBoxContent = styled_components_browser_esm/* default.div */.ZP.div(_templateObject12());
var Becomings = styled_components_browser_esm/* default.div */.ZP.div(_templateObject14(), function(props) {
    return !props.isSmallScreen && (0,styled_components_browser_esm/* css */.iv)(_templateObject13());
});
var Link = styled_components_browser_esm/* default.ul */.ZP.ul(_templateObject15(), colors.B1);

;// CONCATENATED MODULE: ./src/pages/talent-plan/participation/Participation.component.js








var TabPane = tabs/* default.TabPane */.Z.TabPane;
var becomings = [
    {
        title: "\u6210\u4E3A Contributor",
        desc: "\u5F53\u4F60\u5411 Talent Plan \u4E0B\u4EFB\u4F55\u8BFE\u7A0B\u63D0\u4EA4 PR \u5E76\u5F97\u5230\u6279\u51C6\u4E4B\u540E\uFF0C\u4F60\u5C31\u6210\u4E3A\u4E86 Contributor\u3002Talent Plan \u9879\u76EE\u6B22\u8FCE\u5BF9\u8BFE\u7A0B\u5185\u5BB9\u4EE3\u7801\u3001\u6D4B\u8BD5\u7528\u4F8B\u3001\u8BD5\u9898\u3001\u8BFE\u7A0B\u6587\u5B57\u7B49\u5404\u4E2A\u9886\u57DF\u7684\u8D21\u732E\u3002"
    },
    {
        title: "\u6210\u4E3A Mentor",
        desc: "\u6211\u4EEC\u6B22\u8FCE\u719F\u6089\u4E00\u95E8\u8BFE\u7A0B\u6216\u8005\u591A\u95E8\u8BFE\u7A0B\u7684\u5B66\u4E60\u8005\u80FD\u591F\u4ECE\u4E8B\u4F5C\u4E1A\u6279\u6539\u3001\u6280\u672F\u5206\u4EAB\u3001\u5B66\u4E60\u6307\u5BFC\u7B49\u6D3B\u52A8\u3002\u53C2\u52A0\u5176\u4E2D\u4EFB\u4F55\u4E00\u9879\u6D3B\u52A8\uFF0C\u4F60\u5C06\u6210\u4E3A Mentor\u3002"
    },
    {
        title: "\u6210\u4E3A Active Contributor",
        desc: "\u5F53\u4F60\u4E00\u5E74\u5185\u6709 6 \u4E2A PR \u88AB\u63A5\u53D7\u65F6\uFF0C\u4F60\u5C06\u6210\u4E3A\u5F53\u5E74\u5EA6\u7684 Active Contributor"
    },
    {
        title: "\u6210\u4E3A Senior Mentor",
        desc: "\u4E00\u4E2A Mentor \u7D2F\u8BA1\u53C2\u52A0 6 \u6B21\u6D3B\u52A8\uFF0C\u5E76\u4E14\u76F4\u63A5\u8F85\u5BFC 10 \u4EBA\u4EE5\u4E0A\uFF0C\u5C06\u6210\u4E3A Senior Mentor"
    },
    {
        title: "\u6210\u4E3A Committer",
        desc: "Committer \u662F Talent Plan \u9879\u76EE\u4E0B\u67D0\u4E00\u95E8\u6216\u8005\u591A\u95E8\u8BFE\u7A0B\u7684\u4E13\u5BB6\uFF0C\u6216\u8005\u4E00\u95E8\u65B0\u8BFE\u7A0B\u7684\u521B\u5EFA\u4EBA\u3002\u4E00\u822C\u5730\uFF0C\u5F53\u4F60\u7D2F\u8BA1\u63D0\u4EA4 PR \u8FBE\u523030\u4E2A\u65F6\uFF0C\u6216\u8005\u4F60\u4E3A Talent Plan \u521B\u5EFA\u7684\u65B0\u8BFE\u7A0B\u88AB PMC \u63A5\u53D7\u65F6\uFF0C\u4F60\u5E94\u8BE5\u8054\u7CFB PMC \u9610\u8FF0\u4F60\u7684\u8D21\u732E\u3002\u5F53\u4F60\u83B7\u5F97 3+ PMC \u6210\u5458\u7684\u540C\u610F\u4E4B\u540E\uFF0C\u4F60\u5C06\u6210\u4E3A\u4E00\u540DCommitter\u3002"
    }, 
];
var Participation = function() {
    var ref = (0,react.useState)(true), isOnFirstTab = ref[0], setIsOnFirstTab = ref[1];
    var isSmallScreen = (0,useIsSmallScreen/* default */.Z)().isSmallScreen;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(partitcipation_styled_Container, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(partitcipation_styled_Content, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Title */.Dx, {
                            id: "learn",
                            children: "\u6DF1\u5EA6\u53C2\u4E0E Talent Plan"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs/* default */.Z, {
                            onChange: function(idx) {
                                return setIsOnFirstTab(idx === "1");
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPane, {
                                    tab: "\u5B66\u4E60 Talent Plan",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                                        href: "https://github.com/talent-plan/tinysql",
                                                        children: "Talent Plan 301 \u8BFE\u7A0B TinySQL"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "\u5B9E\u73B0\u4E00\u4E2A Mini \u7248\u672C\u7684\u5206\u5E03\u5F0F\u5173\u7CFB\u578B\u6570\u636E\u5E93"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                                        href: "https://github.com/talent-plan/tinykv",
                                                        children: "Talent Plan 302 \u8BFE\u7A0B TinyKV"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "\u5B9E\u73B0\u4E00\u4E2A Mini \u7248\u672C\u7684\u5206\u5E03\u5F0F Key-Value \u6570\u636E\u5E93"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, 1),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPane, {
                                    tab: "\u6210\u4E3A Talent Plan \u5EFA\u8BBE\u8005",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_image/* default */.Z, {
                                        preview: false,
                                        src: getImage("participation-org.jpg")
                                    })
                                }, 2)
                            ]
                        })
                    ]
                })
            }),
            !isOnFirstTab && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerGray, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(partitcipation_styled_Content, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Becomings, {
                        isSmallScreen: isSmallScreen,
                        children: becomings.map(function(el) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BecomingBox, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BecomingBoxContent, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BecomingHeader, {
                                            children: el.title
                                        }),
                                        el.desc
                                    ]
                                })
                            });
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Participation_component = (Participation);

;// CONCATENATED MODULE: ./src/pages/talent-plan/participation/index.js


// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./packages/ui/src/components/link/Link.component.js
var Link_component = __webpack_require__(33358);
;// CONCATENATED MODULE: ./src/pages/talent-plan/nextSteps/nextSteps.styled.js
function nextSteps_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function nextSteps_styled_templateObject() {
    var data = nextSteps_styled_taggedTemplateLiteral([
        "\n  && {\n    color: ",
        ";\n    padding: 0;\n  }\n"
    ]);
    nextSteps_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function nextSteps_styled_templateObject1() {
    var data = nextSteps_styled_taggedTemplateLiteral([
        "\n  position: relative;\n  padding-top: 3rem;\n  padding-bottom: 3rem;\n"
    ]);
    nextSteps_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function nextSteps_styled_templateObject2() {
    var data = nextSteps_styled_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 14px;\n  ",
        "\n  border-radius: 4px;\n  background-color: ",
        ";\n  padding: 48px;\n  margin-bottom: 1rem;\n"
    ]);
    nextSteps_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function nextSteps_styled_templateObject3() {
    var data = nextSteps_styled_taggedTemplateLiteral([
        "\n  padding-bottom: 3rem;\n  position: relative;\n"
    ]);
    nextSteps_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function nextSteps_styled_templateObject4() {
    var data = nextSteps_styled_taggedTemplateLiteral([
        "\n  font-size: 20px;\n  font-weight: bold;\n  padding-bottom: 1rem;\n"
    ]);
    nextSteps_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function nextSteps_styled_templateObject5() {
    var data = nextSteps_styled_taggedTemplateLiteral([
        "\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  display: block;\n"
    ]);
    nextSteps_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function nextSteps_styled_templateObject6() {
    var data = nextSteps_styled_taggedTemplateLiteral([
        "\n  text-decoration: underline !important;\n"
    ]);
    nextSteps_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var nextSteps_styled_Container = (0,styled_components_browser_esm/* default */.ZP)(styled/* Section */.$0)(nextSteps_styled_templateObject(), colors.M1);
var nextSteps_styled_Content = (0,styled_components_browser_esm/* default */.ZP)(styled/* Content */.VY)(nextSteps_styled_templateObject1());
var ProjectCard = styled_components_browser_esm/* default.div */.ZP.div(nextSteps_styled_templateObject2(), colors.F1, mixins/* boxShadow */.Wn(), colors.M2);
var ProjectCardContent = styled_components_browser_esm/* default.div */.ZP.div(nextSteps_styled_templateObject3());
var ProjectCardTitle = styled_components_browser_esm/* default.div */.ZP.div(nextSteps_styled_templateObject4());
var ProjectCardButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).attrs({
    type: "primary"
})(nextSteps_styled_templateObject5());
var nextSteps_styled_Link = (0,styled_components_browser_esm/* default */.ZP)(Link_component/* default */.Z)(nextSteps_styled_templateObject6());

;// CONCATENATED MODULE: ./src/pages/talent-plan/nextSteps/NextSteps.component.js







var NextSteps = function() {
    var router = (0,next_router.useRouter)();
    var onClick = function(link) {
        return function(e) {
            e.preventDefault();
            utils/* link.handleRedirect */.p4.handleRedirect(router, link);
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(nextSteps_styled_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(nextSteps_styled_Content, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Title */.Dx, {
                    children: "\u8FDB\u4E00\u6B65\u63A2\u7D22"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                    gutter: 16,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                            sm: 24,
                            lg: 12,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectCard, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProjectCardContent, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectCardTitle, {
                                                children: " \u53C2\u4E0E TiDB \u5F00\u53D1 "
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "\u672C\u6A21\u5757\u65E8\u5728\u5E2E\u52A9\u8D21\u732E\u8005\u4ECE\u65B0\u624B\u6210\u957F\u4E3A TiDB \u4E13\u5BB6\uFF0C\u719F\u6089 TiDB \u7684\u8BBE\u8BA1\u548C\u5B9E\u65BD\uFF0C\u4ECE\u800C\u80FD\u591F\u5728\u73B0\u5B9E\u4E16\u754C\u4E2D\u6D41\u7545\u5730\u4F7F\u7528\u5B83\uFF0C\u5E76\u8FDB\u884C\u6DF1\u5165\u5F00\u53D1\u5DE5\u4F5C\u3002"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "\u540C\u65F6\u4F60\u4E5F\u53EF\u4EE5\u5728",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(nextSteps_styled_Link, {
                                                        href: "https://internals.tidb.io",
                                                        children: "\u5F00\u53D1\u8005\u8BBA\u575B"
                                                    }),
                                                    "\u548C\u5176\u4ED6\u5F00\u53D1\u8005\u4EEC\u4EA4\u6D41\u5B66\u4E60\u3002"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectCardButton, {
                                                onClick: onClick("https://pingcap.github.io/tidb-dev-guide/get-started/install-golang"),
                                                children: "\u7ACB\u5373\u5B66\u4E60"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectCard, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProjectCardContent, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectCardTitle, {
                                                children: " \u53C2\u52A0\u793E\u533A\u9879\u76EE TiDB for PostgreSQL "
                                            }),
                                            "TiDB for PostgreSQL \u662F\u795E\u5DDE\u6570\u7801\u6B66\u6C49\u4E91\u57FA\u5730\u63A8\u51FA\u7684\u5F00\u653E\u6E90\u7801\uFF0C\u65E8\u5728\u4FC3\u8FDB\u548C\u878D\u5165 TiDB \u7684\u5F00\u6E90\u793E\u533A\u3002\u9664\u4E86\u9AD8\u53EF\u7528\u6027\u3001\u6C34\u5E73\u53EF\u6269\u5C55\u6027\u548C\u4E91\u539F\u751F\u529F\u80FD\u5916\uFF0CPostgreSQL \u7684 TiDB \u8FD8\u4E0E PostgreSQL \u534F\u8BAE\u517C\u5BB9\u3002",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectCardButton, {
                                                onClick: onClick("https://github.com/DigitalChinaOpenSource/TiDB-for-PostgreSQL"),
                                                children: "\u7ACB\u5373\u53C2\u4E0E"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                            sm: 24,
                            lg: 12,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectCard, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProjectCardContent, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectCardTitle, {
                                                children: " \u63A2\u7D22\u66F4\u591A\u793E\u533A\u73A9\u6CD5 "
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                        children: [
                                                            "TiDB \u793E\u533A\u6BCF\u5E74\u4E3E\u529E\u4E0A\u767E\u573A\u6D3B\u52A8\uFF0C\u8986\u76D6\u5F00\u53D1\u8005\u3001\u7528\u6237\u4E0A\u4E07\u4EBA\uFF0C\u6B22\u8FCE",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(nextSteps_styled_Link, {
                                                                href: "https://pingkai.cn/tidbcommunity/events",
                                                                children: "\u53C2\u4E0E\u6D3B\u52A8"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                        children: [
                                                            "\u5982\u679C\u4F60\u5BF9 TiDB \u76F8\u5173\u4EA7\u54C1\u548C\u6280\u672F\u7684\u5E94\u7528\u611F\u5174\u8DA3\uFF0C\u6B22\u8FCE\u6765",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(nextSteps_styled_Link, {
                                                                href: "https://asktug.com",
                                                                children: "\u7528\u6237\u8BBA\u575B"
                                                            }),
                                                            "\u548C",
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(nextSteps_styled_Link, {
                                                                href: "https://pingkai.cn/tidbcommunity/tug",
                                                                children: "TUG \u4EA4\u6D41\u5B66\u4E60"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: "\u66F4\u591A\u6280\u672F\u5185\u5BB9\u8BF7\u524D\u5F80\u535A\u5BA2\u5B66\u4E60"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectCardButton, {
                                                onClick: onClick("https://pingkai.cn/tidbcommunity"),
                                                children: "\u5F00\u59CB\u63A2\u7D22"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectCard, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProjectCardContent, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectCardTitle, {
                                                children: " \u6821\u56ED\u62DB\u8058 "
                                            }),
                                            "PingCAP \u53CA TiDB \u751F\u6001\u4F01\u4E1A\u5411\u4F18\u79C0\u9AD8\u6821\u6BD5\u4E1A\u751F\u655E\u5F00\u5927\u95E8",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectCardButton, {
                                                onClick: onClick("https://campus.pingcap.com/campus_apply/pingcap/39951/#/?anchorName=default_joblist&sourceToken="),
                                                children: "\u7ACB\u5373\u53C2\u4E0E"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var NextSteps_component = (NextSteps);

;// CONCATENATED MODULE: ./src/pages/talent-plan/nextSteps/index.js


;// CONCATENATED MODULE: ./src/pages/talent-plan/organizers/organizers.styled.js
function organizers_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function organizers_styled_templateObject() {
    var data = organizers_styled_taggedTemplateLiteral([
        "\n  && {\n    color: ",
        ";\n    padding: 0;\n    background-color: ",
        ";\n  }\n"
    ]);
    organizers_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function organizers_styled_templateObject1() {
    var data = organizers_styled_taggedTemplateLiteral([
        "\n  position: relative;\n  padding-top: 3rem;\n  padding-bottom: 3rem;\n"
    ]);
    organizers_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function organizers_styled_templateObject2() {
    var data = organizers_styled_taggedTemplateLiteral([
        "\n  display: flex;\n  // horizontally align child elements\n  justify-content: center;\n"
    ]);
    organizers_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function organizers_styled_templateObject3() {
    var data = organizers_styled_taggedTemplateLiteral([
        "\n  // horizontally center the image\n  width: auto;\n  margin: 0 auto;\n"
    ]);
    organizers_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var organizers_styled_Container = (0,styled_components_browser_esm/* default */.ZP)(styled/* Section */.$0)(organizers_styled_templateObject(), colors.M1, colors.M2);
var organizers_styled_Content = (0,styled_components_browser_esm/* default */.ZP)(styled/* Content */.VY)(organizers_styled_templateObject1());
var ImageContainer = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z)(organizers_styled_templateObject2());
var LogoImage = (0,styled_components_browser_esm/* default */.ZP)(es_image/* default */.Z)(organizers_styled_templateObject3());

;// CONCATENATED MODULE: ./src/pages/talent-plan/organizers/Organizers.component.js






var Others = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(organizers_styled_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(organizers_styled_Content, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Title */.Dx, {
                    children: "\u53D1\u8D77/\u7EC4\u7EC7\u8005"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                    gutter: [
                        16,
                        32
                    ],
                    children: [
                        "hust",
                        "ecnu",
                        "digitalchina",
                        "pingcap",
                        "ustc",
                        "whu"
                    ].map(function(name) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer, {
                            xs: 12,
                            md: 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoImage, {
                                preview: false,
                                height: "64px",
                                src: getImage("organization-".concat(name, ".png"))
                            })
                        });
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Organizers_component = (Others);

;// CONCATENATED MODULE: ./src/pages/talent-plan/organizers/index.js


;// CONCATENATED MODULE: ./src/pages/talent-plan/stories/stories.styled.js
function stories_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function stories_styled_templateObject() {
    var data = stories_styled_taggedTemplateLiteral([
        "\n  && {\n    color: ",
        ";\n    padding: 0;\n  }\n"
    ]);
    stories_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function stories_styled_templateObject1() {
    var data = stories_styled_taggedTemplateLiteral([
        "\n  position: relative;\n  padding-top: 3rem;\n  padding-bottom: 3rem;\n  color: ",
        ";\n"
    ]);
    stories_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function stories_styled_templateObject2() {
    var data = stories_styled_taggedTemplateLiteral([
        "\n  height: 100%;\n  padding-bottom: 1rem;\n"
    ]);
    stories_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function stories_styled_templateObject3() {
    var data = stories_styled_taggedTemplateLiteral([
        "\n  ",
        "\n  border-radius: 4px;\n  background-color: ",
        ";\n\n  cursor: pointer;\n  height: 100%;\n\n  padding: 2rem 2rem calc(2rem + 64px) 2rem;\n  border-top: 4px solid ",
        ";\n"
    ]);
    stories_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function stories_styled_templateObject4() {
    var data = stories_styled_taggedTemplateLiteral([
        "\n  height: 64px;\n  display: flex;\n  position: absolute;\n  align-items: center;\n  bottom: 2rem;\n"
    ]);
    stories_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function stories_styled_templateObject5() {
    var data = stories_styled_taggedTemplateLiteral([
        "\n  font-size: 20px;\n  line-height: 1.2;\n"
    ]);
    stories_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function stories_styled_templateObject6() {
    var data = stories_styled_taggedTemplateLiteral([
        "\n  font-size: 16px;\n"
    ]);
    stories_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function stories_styled_templateObject7() {
    var data = stories_styled_taggedTemplateLiteral([
        "\n  padding-left: 1rem;\n"
    ]);
    stories_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var stories_styled_Container = (0,styled_components_browser_esm/* default */.ZP)(styled/* Section */.$0)(stories_styled_templateObject(), colors.M2);
var stories_styled_Content = (0,styled_components_browser_esm/* default */.ZP)(styled/* Content */.VY)(stories_styled_templateObject1(), colors.F1);
var CardWrap = styled_components_browser_esm/* default.div */.ZP.div(stories_styled_templateObject2());
var StoryCard = styled_components_browser_esm/* default.div */.ZP.div(stories_styled_templateObject3(), mixins/* boxShadow */.Wn(), colors.M2, colors.B1);
var StoryCardBottom = styled_components_browser_esm/* default.div */.ZP.div(stories_styled_templateObject4());
var StoryCardInfoName = styled_components_browser_esm/* default.div */.ZP.div(stories_styled_templateObject5());
var StoryCardInfoDesc = styled_components_browser_esm/* default.div */.ZP.div(stories_styled_templateObject6());
var StoryCardInfo = styled_components_browser_esm/* default.div */.ZP.div(stories_styled_templateObject7());

;// CONCATENATED MODULE: ./src/pages/talent-plan/stories/Stories.component.js






var stories = [
    {
        content: "\u6211\u8D85\u7EA7\u559C\u6B22 PingCAP \u7684\u6C1B\u56F4\u8FD8\u6709\u57F9\u8BAD\u65B9\u5F0F\u3002\u8FD9\u6B21\u57F9\u8BAD\u4ECE\u8BED\u8A00\u548C\u6570\u636E\u5E93\u7406\u8BBA\u5B66\u4E60\u5230\u8DDF\u8FDB\u6700\u65B0\u8BBA\u6587\uFF0C\u518D\u5230\u52A8\u624B\u5B9E\u64CD\u5C0F Demo\uFF0C\u4E86\u89E3\u4E86 TiDB \u5404\u4E2A\u6A21\u5757\u7684\u4EE3\u7801\uFF0C\u4E30\u5BCC\u7684\u8BFE\u7A0B\u8BA9\u6211\u5BF9\u6570\u636E\u5E93\u7684\u7406\u89E3\u53C8\u52A0\u6DF1\u4E86\u4E00\u5C42\u3002\u5E0C\u671B\u81EA\u5DF1\u4EE5\u540E\u7684\u7814\u7A76\u4E1C\u897F\u80FD\u591F\u66F4\u8D34\u8FD1\u5230\u5177\u4F53\u7684\u573A\u666F\u548C\u7CFB\u7EDF\u4E2D\u53BB\u53D1\u73B0\u95EE\u9898\uFF0C\u5E76\u628A\u81EA\u5DF1\u7684\u7814\u7A76\u6210\u679C\u843D\u5730\u3002",
        name: "\u5170\u6D77",
        desc: "\u7B2C\u4E00\u671F\u7EBF\u4E0B\u8BFE\u7A0B\u4F18\u79C0\u5B66\u5458"
    },
    {
        content: "\u53C2\u52A0\u4E86 Talent  Plan \u662F\u4E00\u6B21\u975E\u5E38\u73CD\u8D35\u7684\u4F53\u9A8C\uFF0C\u4E00\u65B9\u9762\u662F\u5B66\u5230\u4E86\u8BB8\u591A\u7684\u6CA1\u6709\u63A5\u89E6\u8FC7\u7684\u5206\u5E03\u5F0F\u9886\u57DF\u7684\u77E5\u8BC6\uFF0C\u53E6\u4E00\u65B9\u9762\u4E5F\u7ED3\u8BC6\u4E86\u6765\u81EA\u5168\u56FD\u5404\u4E2A\u9AD8\u6821\u7684\u4F18\u79C0\u7684\u5C0F\u4F19\u4F34\u4EE5\u53CA PingCAP \u7684\u5404\u4F4D\u5389\u5BB3\u7684\u5BFC\u5E08\uFF0C\u4E5F\u4E3A\u6211\u4E4B\u540E\u6765PingCAP \u5B9E\u4E60\u57CB\u4E0B\u4E86\u4F0F\u7B14\u3002",
        name: "\u5F20\u827A\u6587",
        desc: "\u7B2C\u4E8C\u671F\u7EBF\u4E0B\u8BFE\u7A0B\u4F18\u79C0\u5B66\u5458"
    },
    {
        content: "\u53C2\u52A0\u8FD9\u6B21 Talent Plan\uFF0C\u6211\u4E0D\u4EC5\u5B66\u4E60\u5230\u4E86\u4E30\u5BCC\u7684\u77E5\u8BC6\uFF0C\u8FD8\u6DF1\u5165\u5730\u53C2\u4E0E\u5230\u5177\u6709\u6311\u6218\u6027\u7684\u5DE5\u7A0B\u9879\u76EE\u3002\u66F4\u91CD\u8981\u7684\u662F\u4EA4\u5230\u4E86\u4E00\u7FA4\u975E\u5E38\u4F18\u79C0\u3001\u9760\u8C31\u7684\u670B\u53CB\u3002\u975E\u5E38\u611F\u8C22 PingCAP \u4E3E\u529E\u8FD9\u4E2A\u6D3B\u52A8\uFF0C\u5E0C\u671B Talent Plan \u8D8A\u529E\u8D8A\u597D\u3002",
        name: "\u9EC4\u6587\u4FCA",
        desc: "\u7B2C\u4E09\u671F\u7EBF\u4E0B\u8BFE\u7A0B\u4F18\u79C0\u5B66\u5458"
    },
    {
        content: "\u7ECF\u8FC7 Talent Plan \u7684\u5B66\u4E60\u8BA9\u6211\u660E\u767D\u4E86\uFF0C\u5728\u5B9E\u9A8C\u5BA4\u91CC fancy \u7684\u60F3\u6CD5\u5728\u5DE5\u4E1A\u754C\u53EF\u80FD\u5E76\u4E0D work\uFF0C\u5B9E\u9645\u5E94\u7528\u73AF\u5883\u8981\u6BD4\u5B9E\u9A8C\u5BA4\u73AF\u5883\u4E25\u683C\u82DB\u523B\u5F88\u591A\u5F88\u591A\u3002\u7ECF\u8FC7\u8FD9\u6B21\u7EBF\u4E0B\u8BFE\u7A0B\u7684\u5B66\u4E60\uFF0C\u6211\u4EE5\u540E\u5728\u8BBE\u8BA1\u65B9\u6848\u7684\u65F6\u5019\u4F1A\u7740\u91CD\u8003\u8651\u4ECE\u73B0\u5B9E\u89D2\u5EA6\u51FA\u53D1\u3002",
        name: "\u90B9\u6B22",
        desc: "\u7B2C\u4E09\u671F\u7EBF\u4E0B\u8BFE\u7A0B\u6700\u5177\u6F5C\u529B\u5956\u83B7\u5F97\u8005"
    },
    {
        content: "\u8FD9\u6B21\u53C2\u52A0 Talent Plan \u6536\u83B7\u5341\u5206\u5DE8\u5927\uFF0C\u9996\u5148\u662F\u8BA4\u8BC6\u4E86\u4E00\u7FA4\u5F88\u68D2\u7684\u5C0F\u4F19\u4F34\uFF0C\u6B63\u5982\u5D14\u79CB\u8001\u5E08\u8BF4\u7684\uFF0C\u4E00\u4E2A\u6708\u65F6\u95F4\u5F88\u77ED\uFF0C\u4F46\u662F\u53CB\u8C0A\u5374\u662F\u4E00\u8F88\u5B50\u7684\u3002\u7136\u540E\uFF0C\u6211\u5BF9\u6574\u4E2A TiDB \u751F\u6001\u4EE5\u53CA\u5176\u4E2D\u7684\u5404\u4E2A\u6A21\u5757\u6709\u4E86\u66F4\u9AD8\u5C42\u6B21\u7684\u8BA4\u8BC6\u548C\u7406\u89E3\uFF0C\u4E5F\u5207\u8EAB\u4F53\u9A8C\u5230\u4E86PingCAP \u5F88 Cool \u7684 Geek \u6C1B\u56F4\uFF0C\u603B\u4E4B\u5EA6\u8FC7\u4E86\u5F88\u6709\u610F\u4E49\u7684\u4E00\u4E2A\u6708\u3002",
        name: "\u6797\u5B81",
        desc: "\u7B2C\u4E09\u671F\u7EBF\u4E0B\u8BFE\u7A0B\u6700\u5177\u6F5C\u529B\u83B7\u5956\u8005"
    },
    {
        content: "\u5DE5\u4F5C\u540E\u53C2\u52A0 Talent Plan \u662F\u975E\u5E38\u795E\u5947\u7684\u4F53\u9A8C\u3002\u5728\u8FD9\u4E0D\u4EC5\u80FD\u5B66\u4E60\u5230 TiDB \u5404\u4E2A\u6A21\u5757\u7684\u57FA\u7840\u7406\u8BBA\uFF0C\u8FD8\u80FD\u542C\u5230\u4E00\u7EBF\u7684\u5F00\u53D1\u76F4\u63A5\u5206\u4EAB\u5728\u751F\u4EA7\u73AF\u5883\u4E2D\u5B9E\u8DF5\u7684\u4E00\u4E9B\u7EC6\u8282\u548C\u7ECF\u9A8C\u3002\u6700\u540E\u8FD8\u80FD\u548C\u5927\u5BB6\u4E00\u8D77\u9F50\u5FC3\u534F\u529B\u53BB\u843D\u5730\u4E00\u4E2A\u9879\u76EE\uFF0C\u5E76\u89C1\u8BC1\u5B83\u6210\u4E3A\u8FD9\u4E2A\u4F18\u79C0\u5F00\u6E90\u6570\u636E\u5E93\u7684\u4E00\u90E8\u5206\u3002\u611F\u89C9\u81EA\u5DF1\u56DE\u5230\u4E86\u4E45\u8FDD\u7684\u5B66\u751F\u65F6\u5149\u3002",
        name: "\u90D1\u5411\u5347",
        desc: "\u7B2C\u56DB\u671F\u7EBF\u4E0B\u8BFE\u7A0B\u5B66\u5458\u4EE3\u8868"
    },
    {
        content: "\u5728\u4F20\u7EDF\u7684\u8BFE\u5802\u5B66\u4E60\u4E2D\uFF0C\u5982\u679C\u7EC4\u961F\u505A\u4E00\u4E9B\u6BD4\u8F83\u5927\u7684\u4F5C\u4E1A\uFF0C\u6700\u591A\u5C31\u662F\u51E0\u4E2A\u540C\u5B66\u95F4\u8BA8\u8BBA\uFF0C\u8FD9\u79CD\u5355\u5411\u5C0F\u89C4\u6A21\u7684\u601D\u60F3\u4EA4\u6D41\u6BD4\u8F83\u6709\u9650\u3002\u4F46\u901A\u8FC7 Talent Plan \u5B66\u4E60\u793E\u533A\uFF0C\u6211\u4EEC\u53EF\u4EE5\u6C47\u805A\u5168\u56FD\uFF0C\u751A\u81F3\u5168\u4E16\u754C\u7684\u5206\u5E03\u5F0F\u6280\u672F\u7231\u597D\u8005\uFF0C\u5927\u5BB6\u5BF9\u4E8E\u540C\u4E00\u4EF6\u4E8B\u6709\u4E0D\u540C\u7684\u601D\u7EF4\u3001\u601D\u60F3\uFF0C\u5C31\u4F1A\u78B0\u649E\u51FA\u4E00\u4E9B\u5F88\u6709\u610F\u601D\u7684\u601D\u8DEF\u548C\u89E3\u51B3\u65B9\u6CD5\uFF0C\u8FD9\u4E5F\u53EF\u4EE5\u6FC0\u53D1\u5927\u5BB6\u66F4\u6709\u70ED\u60C5\u5730\u53C2\u4E0E\u8FDB\u6765\u3002\u901A\u8FC7 Talent Plan \u7684\u5B66\u4E60\uFF0C\u6211\u4E0D\u4EC5\u5B66\u5230\u4E86\u4E13\u4E1A\u7684\u5206\u5E03\u5F0F\u6570\u636E\u5E93\u77E5\u8BC6\uFF0C\u8FD8\u4EA4\u5230\u5F88\u591A\u670B\u53CB\uFF0C\u4E2A\u4EBA\u975E\u5E38\u559C\u6B22\u8FD9\u79CD\u5F62\u5F0F\u3002",
        name: "\u8C2D\u65B0\u5B87",
        desc: "2021 TinyKV\u5B66\u4E60\u8425\u4F18\u79C0\u5B66\u5458"
    },
    {
        content: "\u4E4B\u524D\u4E5F\u53C2\u52A0\u8FC7\u4E00\u4E9B\u8F6F\u4EF6\u8BBE\u8BA1\u7C7B\u7684\u7ADE\u8D5B\uFF0C\u8FD9\u4E9B\u6BD4\u8D5B\u66F4\u5173\u6CE8\u9879\u76EE\u7684\u5305\u88C5\uFF0C\u800C\u5728 Talent Plan \u5B66\u4E60\u8425\u4E2D\uFF0C\u66F4\u5173\u6CE8\u7684\u662F\u5B66\u751F\u7684\u52A8\u624B\u80FD\u529B\uFF0C\u4EE5\u53CA\u662F\u5426\u575A\u6301\u5230\u5E95\u5C06\u9879\u76EE\u5B8C\u6210\u3002\u901A\u8FC7 Talent Plan\uFF0C\u53EF\u4EE5\u628A\u6240\u5B66\u7684\u77E5\u8BC6\u4E0E\u5B9E\u8DF5\u76F8\u7ED3\u5408\uFF0C\u8FD9\u5BF9\u4E8E\u4E2A\u4EBA\u53D1\u5C55\u662F\u975E\u5E38\u6709\u5E2E\u52A9\u7684\u3002\u672A\u6765\uFF0C\u6211\u4F1A\u7EE7\u7EED\u5F80\u6570\u636E\u5E93\u8FD9\u4E00\u9886\u57DF\u53BB\u53D1\u5C55\uFF0C\u4ECE\u4E8B\u5206\u5E03\u5F0F\u6570\u636E\u5E93\u76F8\u5173\u7684\u7814\u53D1\u662F\u6211\u6700\u611F\u5174\u8DA3\u7684\u4E8B\u60C5\u3002",
        name: "\u9EC4\u7AE0\u8861",
        desc: "2021 TinyKV\u5B66\u4E60\u8425\u4F18\u79C0\u5B66\u5458"
    },
    {
        content: "Talent Plan \u7684\u8BFE\u7A0B\u8BBE\u7F6E\u975E\u5E38\u5408\u7406\uFF0C\u7531\u6D45\u5165\u6DF1\uFF0C\u96BE\u5EA6\u7684\u8DE8\u5EA6\u4E5F\u662F\u6162\u6162\u63D0\u5347\u7684\uFF0C\u5BF9\u4E8E\u5B66\u5458\u6765\u8BF4\u6BD4\u8F83\u53CB\u597D\u3002\u56E0\u4E3A\u6211\u7684\u4E13\u4E1A\u5C31\u662F\u6570\u636E\u5E93\u76F8\u5173\uFF0C\u5BF9\u8FD9\u4E9B\u77E5\u8BC6\u5176\u5B9E\u5E76\u4E0D\u964C\u751F\u3002\u4F46\u4E4B\u524D\u7684\u5B66\u4E60\u7ECF\u5386\u504F\u5B66\u672F\u754C\uFF0CTalent Plan \u7684\u8BFE\u7A0B\u66F4\u4FA7\u91CD\u5DE5\u4E1A\u754C\u7684\u5B9E\u8DF5\uFF0C\u6765\u81EA\u4E8E\u5B9E\u9645\u5E94\u7528\u573A\u666F\u4E2D\u3002\u901A\u8FC7 Talent Plan \u7684\u5B66\u4E60\uFF0C\u53EF\u4EE5\u5E2E\u52A9\u6211\u628A\u5B66\u672F\u754C\u7684\u7406\u8BBA\u548C\u5DE5\u4E1A\u754C\u7684\u5B9E\u8DF5\u7ED3\u5408\u8D77\u6765\uFF0C\u8FDB\u4E00\u6B65\u63D0\u5347\u4E13\u4E1A\u77E5\u8BC6\u3002",
        name: "\u5B59\u4F73\u4E3D",
        desc: "2021 TinyKV\u5B66\u4E60\u8425\u4F18\u79C0\u5B66\u5458"
    }, 
];
var Stories_component_Others = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(stories_styled_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(stories_styled_Content, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Title */.Dx, {
                    children: "\u5B66\u5458\u6545\u4E8B"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                    gutter: 16,
                    children: stories.map(function(story) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                            xs: 24,
                            md: 12,
                            lg: 8,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardWrap, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StoryCard, {
                                    children: [
                                        story.content,
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StoryCardBottom, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* default */.C, {
                                                    src: getImage("team-".concat(story.name, ".jpg")),
                                                    size: 48
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StoryCardInfo, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StoryCardInfoName, {
                                                            children: [
                                                                " ",
                                                                story.name,
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StoryCardInfoDesc, {
                                                            children: [
                                                                " ",
                                                                story.desc,
                                                                " "
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }, story.name);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Stories_component = (Stories_component_Others);

;// CONCATENATED MODULE: ./src/pages/talent-plan/stories/index.js


;// CONCATENATED MODULE: ./src/pages/talent-plan/others/others.styled.js
function others_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function others_styled_templateObject() {
    var data = others_styled_taggedTemplateLiteral([
        "\n  && {\n    color: ",
        ";\n    padding: 0;\n  }\n"
    ]);
    others_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function others_styled_templateObject1() {
    var data = others_styled_taggedTemplateLiteral([
        "\n  position: relative;\n  padding-top: 3rem;\n  color: ",
        ";\n"
    ]);
    others_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function others_styled_templateObject2() {
    var data = others_styled_taggedTemplateLiteral([
        "\n  text-decoration: underline !important;\n"
    ]);
    others_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var others_styled_Container = (0,styled_components_browser_esm/* default */.ZP)(styled/* Section */.$0)(others_styled_templateObject(), colors.M1);
var others_styled_Content = (0,styled_components_browser_esm/* default */.ZP)(styled/* Content */.VY)(others_styled_templateObject1(), colors.F1);
var others_styled_Link = (0,styled_components_browser_esm/* default */.ZP)(Link_component/* default */.Z)(others_styled_templateObject2());

;// CONCATENATED MODULE: ./src/pages/talent-plan/others/Others.component.js




var Others_component_Others = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(others_styled_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(others_styled_Content, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Title */.Dx, {
                    children: "\u5176\u4ED6\u8D44\u6E90"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                "\u5982\u679C\u4F60\u5BF9\u5206\u5E03\u5F0F\u6570\u636E\u5E93\u6BD4\u8F83\u964C\u751F\uFF0C\u5EFA\u8BAE\u5148\u4ECE PingCAP Education \u5B66\u4E60\u7F51\u7AD9",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(others_styled_Link, {
                                    href: "https://learn.pingcap.cn/learner/course/600003",
                                    children: "TiDB \u5165\u95E8\u8BFE\u7A0B"
                                }),
                                " ",
                                "\u5F00\u59CB\u5165\u624B\u3002\u4F60\u4E5F\u53EF\u4EE5\u901A\u8FC7\u795E\u5DDE\u6570\u7801\u5236\u4F5C\u7684",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(others_styled_Link, {
                                    href: "https://www.bilibili.com/video/BV1Zh411i7Tp/?spm_id_from=333.337.search-card.all.click&vd_source=448ecb3691855b619da9f75851b12964",
                                    children: "\u5206\u5E03\u5F0F\u6570\u636E\u5E93\u5E94\u7528"
                                }),
                                "\u548C",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(others_styled_Link, {
                                    href: "https://www.bilibili.com/video/BV1S14y1P7Mb/?spm_id_from=333.337.search-card.all.click&vd_source=448ecb3691855b619da9f75851b12964",
                                    children: "\u5206\u5E03\u5F0F\u6570\u636E\u5E93\u5F00\u53D1"
                                }),
                                "\u4E86\u89E3\u6570\u636E\u5E93\u5B9E\u73B0\u3002"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(others_styled_Link, {
                                    href: "https://cn.pingcap.com/blog/?tag=TiDB%20%E6%BA%90%E7%A0%81%E9%98%85%E8%AF%BB,TiKV%20%E6%BA%90%E7%A0%81%E8%A7%A3%E6%9E%90",
                                    children: "TiDB \u6E90\u7801\u9605\u8BFB"
                                }),
                                "\u5E94\u8BE5\u5BF9\u4F60\u7684 Talent Plan \u5B66\u4E60\u6709\u6240\u5E2E\u52A9\u3002"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(others_styled_Link, {
                                    href: "https://github.com/pingcap/awesome-database-learning",
                                    children: "Awesome-db-learning"
                                }),
                                " ",
                                "\u6536\u96C6\u4E86\u6570\u636E\u5E93\u548C\u5206\u5E03\u5F0F\u5B58\u50A8\u65B9\u5411\u7684\u4F18\u8D28\u8BBA\u6587\u3001\u535A\u6587\u3001\u4E66\u7C4D\u548C\u8BFE\u7A0B\u3002\u5E0C\u671B\u80FD\u52A9\u4F60\u4E00\u81C2\u4E4B\u529B\u3002"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                "\u5982\u679C\u5E0C\u671B\u5BF9 TiDB \u6709\u6DF1\u5165\u4E86\u89E3\uFF0C\u53EF\u4EE5\u53C2\u8003",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(others_styled_Link, {
                                    href: "https://github.com/tidb-incubator/tidb-in-action",
                                    children: "TiDB in Action"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                "\u5982\u679C\u5E0C\u671B\u5BF9\u4EA7\u4E1A\u754C\u5982\u4F55\u4F7F\u7528 NewSQL \u6570\u636E\u5E93\uFF0C\u53EF\u4EE5\u53C2\u8003",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(others_styled_Link, {
                                    href: "https://github.com/pingcap/presentations",
                                    children: "TiDB\u793E\u533A\u8D44\u6599\u96C6\u9526"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Others_component = (Others_component_Others);

;// CONCATENATED MODULE: ./src/pages/talent-plan/others/index.js


;// CONCATENATED MODULE: ./src/pages/talent-plan/ranking/Ranking.styled.ts
function Ranking_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Ranking_styled_templateObject() {
    var data = Ranking_styled_taggedTemplateLiteral([
        "\n  && {\n    color: ",
        ";\n    padding: 0;\n  }\n"
    ]);
    Ranking_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Ranking_styled_templateObject1() {
    var data = Ranking_styled_taggedTemplateLiteral([
        "\n  margin-top: 4rem;\n  position: relative;\n"
    ]);
    Ranking_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Ranking_styled_templateObject2() {
    var data = Ranking_styled_taggedTemplateLiteral([
        "\n  height: 0;\n  width: 100%;\n\n  background-image: url('",
        "');\n  padding-top: calc(",
        " * 100%);\n  // background image full width\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n\n  margin-bottom: 1rem;\n"
    ]);
    Ranking_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Ranking_styled_templateObject3() {
    var data = Ranking_styled_taggedTemplateLiteral([
        "\n  color: #2c2c2c;\n  a {\n    color: ",
        ";\n    :hover {\n      text-decoration: underline;\n    }\n  }\n"
    ]);
    Ranking_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var Ranking_styled_Container = (0,styled_components_browser_esm/* default */.ZP)(styled/* Section */.$0)(Ranking_styled_templateObject(), colors.M1);
var Ranking_styled_Content = (0,styled_components_browser_esm/* default */.ZP)(styled/* Content */.VY)(Ranking_styled_templateObject1());
var Ranking_styled_Banner = styled_components_browser_esm/* default.div */.ZP.div(Ranking_styled_templateObject2(), function(props) {
    return getImage("ranking-tikv-banner".concat(props.sm ? "-mobile" : "", ".svg"));
}, function(props) {
    return props.sm ? 397 / 428 : 260 / 1332;
});
var Ranking_styled_Link = styled_components_browser_esm/* default.ul */.ZP.ul(Ranking_styled_templateObject3(), colors.B1);

;// CONCATENATED MODULE: ./src/pages/talent-plan/ranking/Ranking.component.tsx


//import { Table } from 'antd';
//import { tikv_columns, tikv_columns_participation, tikv_data } from './datasource';



var Ranking = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Ranking_styled_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Ranking_styled_Content, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Title */.Dx, {
                    children: "\u5B66\u4E60\u6D3B\u52A8"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Ranking_styled_Link, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/1026636/1",
                                children: "Talent Plan 2024 \u5BFC\u5B66\u516C\u5F00\u8BFE"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                href: "https://mp.weixin.qq.com/s/aFgvpLz3NN15aGDmMwZ71w#/",
                                children: "Talent Plan \u8BFE\u7A0B\u5165\u9009\u5F00\u653E\u539F\u5B50\u6821\u6E90\u884C\u9996\u6279\u4F18\u8D28\u5F00\u6E90\u8BFE\u7A0B"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                    href: "https://mp.weixin.qq.com/s/gn-hzLGXTqMG418evx98bw",
                                    children: "Talent Plan \u5B50\u8BFE\u7A0B\u652F\u6301\u4E2D\u56FD\u6570\u636E\u5E93\u6691\u671F\u5B66\u6821 2023"
                                }),
                                " ",
                                "\uFF08\u5DF2\u7ED3\u675F\uFF09"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "2023 Talent Plan \u534E\u4E2D\u79D1\u6280\u5927\u5B66\u6691\u671F\u8BAD\u7EC3\u8425 \uFF08\u5DF2\u7ED3\u675F\uFF09"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                    href: "https://pingkai.cn/tidbcommunity/forum/t/topic/665861",
                                    children: "2022 \u5E74 Talent Plan tinyKV \u5B66\u4E60\u8425"
                                }),
                                " ",
                                "\uFF08\u5DF2\u7ED3\u675F\uFF09"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                    href: "https://pingkai.cn/tidbcommunity/forum/t/topic/665106",
                                    children: "2022 \u5E74 Talent Plan \u5206\u5E03\u5F0F\u4E8B\u52A1\u77ED\u8BAD\u8425"
                                }),
                                " ",
                                "\uFF08\u5DF2\u7ED3\u675F\uFF09"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                    href: "https://pingkai.cn/tidbcommunity/forum/t/topic/393068",
                                    children: "2021 \u5E74 Talent Plan tinyKV \u5B66\u4E60\u8425"
                                }),
                                " ",
                                "\uFF08\u5DF2\u7ED3\u675F\uFF09"
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Ranking_component = (Ranking);

;// CONCATENATED MODULE: ./src/pages/talent-plan/ranking/index.ts


;// CONCATENATED MODULE: ./src/pages/talent-plan/index.page.tsx














var Page = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CommunityHead */.Wh, {
                title: "Talent Plan",
                description: "\u4EE5 Talent Plan \u5F00\u6E90\u6570\u636E\u5E93\u5F00\u53D1\u8BFE\u7A0B\u4E3A\u4F9D\u6258\uFF0C\u8054\u5408\u4F18\u79C0\u9AD8\u6821\u548C\u4F01\u4E1A\uFF0C\u5EFA\u8BBE\u6210\u5BF9\u5168\u56FD\u5404\u9AD8\u6821\u6570\u636E\u5E93\u5F00\u53D1\u4EBA\u624D\u57F9\u517B\u7684\u6700\u4F73\u5B9E\u8DF5\u5E73\u53F0\u3002\u65E2\u80FD\u5E2E\u52A9\u5B66\u4E60\u8005\u638C\u63E1\u6570\u636E\u5E93\u5F00\u53D1\u7684\u7406\u8BBA\u77E5\u8BC6\uFF0C\u8FDB\u884C\u5B9E\u9645\u6570\u636E\u5E93\u5F00\u53D1\u953B\u70BC\uFF0C\u53C8\u80FD\u7ED9\u4E0E\u5B66\u4E60\u8005\u4F7F\u7528\u5F00\u6E90\u8D44\u6E90\uFF0C\u5F00\u53D1\u5F00\u6E90\u8F6F\u4EF6\u7684\u57F9\u517B\u3002"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* CoreLayout */.N, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner_component, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Participation_component, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Ranking_component, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Labs_component, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Institutes_component, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Team_component, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NextSteps_component, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Organizers_component, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Others_component, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stories_component, {})
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var index_page = (Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5180,4458,9774,2888,179], function() { return __webpack_exec__(61863); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);